/**
 * Created by Marcus Zhao on 01/23/2019.
 *  Description:
 *      copy some  business logic from iPhone Code
 *      create Template dialog
 *      Init web UI Custom layout
 *      Use  Kendo UI (DropdownList) as control component
 * ------ maintenance history ------
 * 04/08/2019 Yoyo Fang - change attachments dirty check from attachments level to each file level
 * 05/14/2019 Bowen Li - add isPrivacy attribute to control New Note dialog: Note type style
 * 06/18/2019 Bowen Li - disabled the publish button when click the publish
 * Updated by Abner Sui on 06/20/2019
 * Show auto save time
 * 06/20/2019 Yoyo Fang - conditionally pass keepdoc property for note create/update api calls
 * Updated by Abner Sui on 07/12/2019
 * Auto save in 3s and 30s
 * 07/17/2019 Marcus Zhao  Add useDefaultValue for judge new controller need load default value
 * 08/21/2019 Marcus Zhao  Add 'action' in preSave() function for judge the note action  .
 * 09/23/2019 Marcus Zhao - move the _relationshipSaveAction() to templateService and use templateService.relationshipSaveAction();
 * 12/03/2019 Marcus Zhao - Add  entryform to judge keep note body info
 * 2/6/2020 Daniel - Add auto tag
 * 09/04/2020 Marcus Zhao - Add intralink data for create entry.
 * 08/23/2021 Marcus Zhao - Add autoSaved as a conditions for close dialog function.
 * 05/16/2022 Alex Xia - Add logics of opening new note dialog for office add-in.
 * 07/28/2022 Marcus Zhao - Move get attachment file from get addin data function.
 * Get the attachment separately, and callback the progress through callback, because the real progress cannot be * obtained at present. So let's use the progress of the simulation.
 * 08/17/2022 Alex Xia - Add logic to support word add-in.
 * 09/22/2022 Marcus Zhao - transform to event dialog。
 * 10/28/2022 Simon Zhao - Notify alert window to work under compact view for Add-in.
 */
import { OnInit, Renderer2, Component, OnDestroy, ViewChild, HostListener, ElementRef, ViewContainerRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { businessConstants as webBusinessConstants } from '../../constants/business.constants';
import { NoteDialogService } from './note-dialog.service';
import { Subscription, Subject, ReplaySubject, fromEvent } from 'rxjs';
import { MailBoxItemSource, MailBoxItemType, NoteDialogOpenOptions, NoteDialogType } from './note-dialog.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { EntryType } from '@tamalelibs/models/entry-type.model';
import { DialogService } from '@progress/kendo-angular-dialog';
import { SET_NOTE_BODY_FOR_EDITING, NOTE_BODY_ENTER_EDITING } from '@tamalelibs/redux/template.actions';
import { filter, debounceTime, take } from 'rxjs/operators';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { TemplateService } from '@tamalelibs/services/template.service';
import * as CAT from '@tamalelibs/constants/logger.constants';
import { TemplateDialogService } from '../template/template-dialog.service';
import { NoteAttachmentsConfig, NoteAttachmentsAction, NoteAttachmentsActionTypes, NoteAttachmentsFeedbackTypes } from '../../components/note-attachments/note-attachments.model';
import { NoteEntry } from '@tamalelibs/models/note-entry.model';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';
import { NoteBodyAction } from '@tamalelibs/models/note-body-action.model';
import { BlastEmail } from '@tamalelibs/models/blastemail.model';
import { AppState } from '../../redux';
import { Store } from '@ngrx/store';
import * as _lodash from 'lodash';
import { FloatMenuService, DraftActionType } from '../../services/float-menu.service';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { OfficeAddIn } from '@tamalelibs/models/office-addin.model';
import { PluginService } from '../../services/plugin.service';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { FormulaService } from '../../services/formula-service';
import {
    DELETE_AUTOSAVED_DRAFT, AUTO_CREATE_DRAFT_SUCCESS, AUTO_CREATE_DRAFT_FAILURE,
    AUTO_UPDATE_DRAFT_FAILURE, CREATE_NOTE_SUCCESS, UPDATE_NOTE_SUCCESS,
    CREATE_DRAFT_SUCCESS, UPDATE_DRAFT_SUCCESS, CREATE_NOTE_FAILURE,
    UPDATE_NOTE_FAILURE, CREATE_DRAFT_FAILURE, UPDATE_DRAFT_FAILURE,
    DELETE_AUTOSAVED_DRAFT_SUCCESS, DELETE_AUTOSAVED_DRAFT_FAILURE, REMOVE_ENTITIES, CLEAN_REMOVE_ENTITIES, SAVE_NOTE
} from '@tamalelibs/redux/note.actions';
import { NoteActions, AUTO_SAVE_INTERVAL_30, AUTO_SAVE_INTERVAL_3, StandardControlIds, businessConstants, ComponentTypes } from '@tamalelibs/constants/business.constants';
import { bizConstants } from '../../constants/biz.constants';
import { BriefObject } from '@tamalelibs/models/brief-object';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BriefConfig } from '../../widgets/widgets.model';
import { DialogAction } from '../../widgets/tam-dialog/tam-dialog.model';
import { IntralinksFile } from '@tamalelibs/models/intralinks.model';
import { DocumentEmail } from '@tamalelibs/models/document-email.model';
import { IntralinksValidationService } from './../intralinks-validation/intralinks-validation.service';
import { unCategorizedId } from '../../redux/reducers/system.reducer';
import { StoreQuerierService } from '../../services/store-querier.service';
import { StringHelperService } from '@tamalelibs/services/string-helper.service';
import { CLEAR_DUPLICATED_CONTACT } from '@tamalelibs/redux/contact.actions';
import { MessageType } from '@tamalelibs/models/message.model';
import { MessageService } from '../../services/message.service';
import { FileHelperService } from '../../services/file-helper.service';
import { AddInUtilities } from '../../services/utilities/addin-utilities';
import { getNoteSelector } from '@tamalelibs/redux/note.reducer';
import { WindowRef } from '../../services/window-ref';
import { AddInGlobalModel, AddInDepositType, AddInType } from '../../models/addin.model';
import { UUID } from 'angular2-uuid';
import { CalendarDialogOpenOptions, CalendarDialogTriggerSource, CalendarDialogType } from '../calendar-dialog/calendar-dialog.model';
import { CalendarDialogService } from '../calendar-dialog/calendar-dialog.service';
import { AlertBtnTypes, AlertButton, AlertViewType } from '../../widgets/alert-window/alert-window.model';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'note-dialog',
    templateUrl: './note-dialog.component.html',
    styleUrls: ['./note-dialog.component.scss'],
    providers: [WebTemplateViewModel, DialogService],
    standalone: false
})

export class NoteDialogComponent implements OnInit, OnDestroy {

    @ViewChild('dialogRef', { static: true }) dialogRef;

    viewContainer: ViewContainerRef;
    allowCustom = false;
    addinSuccessTip = StringLiteralsPipe.translate('addin.note_successfully_created');
    addinAutoSavedTip = StringLiteralsPipe.translate('note.auto_saved');
    addinAutoSavingTip = StringLiteralsPipe.translate('note.saving');
    addinSaveAsDraftTip = StringLiteralsPipe.translate('note.save_as_draft');
    publishTip = StringLiteralsPipe.translate('general.publish');
    cancelTip = StringLiteralsPipe.translate('general.cancel');
    opened: boolean;
    dialogWidth = 684;
    dialogWidthForPlugin = 684;
    isDialogClosedForPlugin = 10; // 10 stands for open;20 stands for closed
    titleName: string;
    isShow = false;
    entry: NoteEntry;
    isPlugInEditNoteMode = false; // for notebody editing mode which is from office plugins.
    canSaveAsDraft = false;
    valueChangeSubject: Subject<any>; // for notifying other control about value set change
    autoTagSubject: Subject<any> = new Subject<any>();
    valueChangeSubscribtionForPer30: Subscription;
    valueChangeSubscribtionForPer3: Subscription;
    autoSaveTime: Date;
    isAutoSaving = false;
    domainUrl: string;
    noteAttachmentsConfig: NoteAttachmentsConfig;
    isDraft = false; // mark if note template is triggered by drafts
    isPopupEntry = false;
    isOutlookAddinMode = false; // only outlook addin mode.
    hideControl = 'Hide metadata';
    clickHideControl = false;
    dialogConfig: BriefConfig = new BriefConfig();
    isHidePopOut = false;
    // Switch to a single layer layout
    isSingleTemplate = false;
    totalHeight;
    isNeedReload: boolean;
    // single layer template for addin or other scenario
    singleLayerConfig = [];
    sentimentConfig = {};
    tplConfig = [];

    // office add-in
    addinSubject = '';
    isDialogHidden = false;
    isOfficeAddinMode = false; // to support office add-in
    isShowBtnClose = true;
    checkboxValue = false;

    private _currentAttachemtId: string;
    private _calendarParams: CalendarDialogOpenOptions;
    private _deletedFileIds = []; // to store the file ids that are deleted in the uploading process
    private _notifyAction: any;
    private _el: HTMLElement;
    private _infoToast: NotificationOptions = {
        message: 'Saved to Draft',
        style: NotificationStyles.Info
    };
    // logic flags
    private _isOfficeAddinPinMode = false; // to support office add-in
    private _privacyTeamsInited = false; // mark if privacy is initialized
    private _noteTypeInited = false; // mark if current note type is initialized
    private _gotNoteBody = false; // mark if the note body is got from note body CKEditor
    private _noteBodyEditorLoaded = false; // mark if note body ck editor is loaded
    private _firstOpen = true; // mark if the window is opened for the first time, no matter create or edit
    // mark if the entities field should be disabled, disable entities field in create sidnote mode when parent note is note editable
    private _disableEntityField = false;
    // mark if a note is being saved, to prevent user clicks 'draft' or 'publish' button twice very quickly to create two duplicate notes
    private _savingNote = false;
    private _filePath = ''; // mark the file path for share file to note
    private _isPreNoteEntryForm = false; // mark the last noteType for switching notetype logic
    private _isSelectMulFolder = false; // mark if multiple documents are selected in multiple folders

    // UI flgs
    privacyEnabled = false; // mark if privacy is enabled
    privacyListDefalult: Array<any>;
    private _privacyTeam: any = {};
    private _dirtyAttachments: string[] = [];
    public attachmentUploading = false;
    public attachmentRenaming = false;
    public publishButtonHasBeenClicked = false;
    public isPrivacy = false;
    // data models
    private _currentEntity: any;
    private _entry: any; // mark the entry value for note editing
    private _noteTypes: Array<EntryType>; // save the note type dropdown data set
    private _noteTypesSource: Array<EntryType>;
    private _noteTypeDefalult: EntryType; // set the default not type;
    private _noteTypeId: string; // save the selected note type ID
    private _privacyList: Array<any>;
    private _privacyListSource: Array<any>;

    private _templateValueSet: any = {}; // mark the template control's values, based on controlId
    private _noteAction: string; // addNote, editNote, addSidenote, editSidenote, get this from routing URL
    private _saveAction: string; // saveNote, saveDraft
    editingEntryId: string; // the entryId that is being edited, get this from routing URL
    private _createEntryId = ''; // the entryId that is being create by blastemail, get this from routing URL
    private _newEntitiesFieldValue: Array<string> = []; // mark the new eneties field values when changed in create/edit
    private _noteBodyHtml = ''; // cache note body html, used when switching note types and publishing/drafting notesidenote mode
    private _dialogOpenOptions: NoteDialogOpenOptions;
    // mark the previous template value set when switching note types, based on adhocId workflows
    private _previousTemplateValueSet: any = {};
    private _processingUploads = [];
    private _blastEmail: BlastEmail; // BlastEmail data from blastEmail Page
    private _noteBodySubject: Subject<NoteBodyAction> = new Subject<NoteBodyAction>(); // for notifying note body to get note body string
    private _autoSaveTimerPer30: any = null;
    private _autoSaveTimerPer3: any = null;
    private _isAutoSavingPer30 = false;
    private _isAutoSavingPer3 = false;
    private _pausedAutoSave = false;
    private _destroySubscriptions: Array<Subscription> = [];
    private _autoSaved = false;
    // rxjs ngrx/store subscriptions
    private _dropzoneSubscription$: Subscription; // global dropzone action subscription
    private _teamplateMsgSubscriptions: Subscription;
    private _publishSubject$: Subject<any> = new Subject(); // for date components.
    private _widthFactor = 1.2; // Calculate the Size Ratio
    private _autoTagEntities = [];
    private _removedEntities = [];
    private isIPAD = false;

    private _clickPopupEntry = false;
    private _msgAction = '';
    private _popoutDraft = false;
    private _intralinksData: IntralinksFile[];
    private _submitIntralinksData: IntralinksFile[];
    private _unCategorizedId = businessConstants.entity.Uncategorized_Fixed_ID;
    private _reloadDraft = 'reloadDraft';
    private _isTriggerAutoSave = false; // when switch note type ,should trigger auto saving.
    private _findFirstControl = false; // TAM-32009
    private _specialCommonentTypes = [ComponentTypes.priority, ComponentTypes.checkbox, ComponentTypes.label, '']; // TAM-32009
    private _downloadFile = false;
    private _defaultSidenoteTypeId = '';

    // office add-in
    private _addinEntryId = '';
    private _noteTemplateConfigurations;
    private _noteTypeResDefault; // save the default type resource for office addin
    private _officeAddIn: OfficeAddIn; // data from office add-in
    private _officeAddInOld: OfficeAddIn; // store data when selecting an email and open it for the first time.

    constructor(
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _element: ElementRef,
        private renderer: Renderer2,
        private _alertWindow: AlertWindowService,
        private _toast: ToastService,
        private _pluginService: PluginService,
        private _noteDialogService: NoteDialogService,
        private _templateService: TemplateService,
        private _templateDialogService: TemplateDialogService,
        private _formulaService: FormulaService,
        private _store: Store<AppState>,
        private _draftService: FloatMenuService,
        private _router: Router,
        private _deviceService: DeviceDetectorService,
        private _intralinksValidationService: IntralinksValidationService,
        private _storeQuerier: StoreQuerierService,
        private _messageService: MessageService,
        private _fileHelperService: FileHelperService,
        private _winRef: WindowRef,
        private _zone: NgZone,
        private _changeDetectorRef: ChangeDetectorRef,
        private _calendarDialogService: CalendarDialogService,
    ) {
        this._noteBodySubject = new Subject<NoteBodyAction>();
        this._el = this._element.nativeElement;
    }

    ngOnInit() {
        document.addEventListener('keydown', this.onDocumentEscape, true);
        this.noteAttachmentsConfig = new NoteAttachmentsConfig();
        this.noteAttachmentsConfig.dropzone = this.dialogRef._element;
        this.publishButtonHasBeenClicked = false;
        this.isHidePopOut = this._deviceService.isMobile() || this._deviceService.isTablet();
        if (this._router.url && this._router.url.indexOf('/popoutentry/') > -1) {
            this.isPopupEntry = true;
        } else {
            this.isPopupEntry = false;
        }
        if (this._router.url && this._router.url.indexOf('draft/popoutentry/') > -1) {
            this._popoutDraft = true;
        } else if (this._router.url && this._router.url.indexOf('new/popoutentry/') > -1) {
            this._popoutDraft = false;
        }
        this._destroySubscriptions.push(
            this._noteDialogService.dialogOpen$.subscribe((dialogOpenOptions: NoteDialogOpenOptions) => {
                this._initOfficeAddIn(dialogOpenOptions);
                if (!this._isOfficeAddinPinMode || dialogOpenOptions.isTransformByCalendar || dialogOpenOptions.isSwitchFromCalendar) {
                    if (this._el.querySelector('.template-dialog') == null || dialogOpenOptions.isSwitchFromCalendar) { // Do not have a minimize dialog or switching from calendar
                        // createOrEdit means create note when no edit minimized
                        if (dialogOpenOptions.openType === NoteDialogType.CreateOrEditNote) {
                            dialogOpenOptions.openType = NoteDialogType.CreateNote;
                        }
                        if (dialogOpenOptions.entryTypeId) {
                            this._createEntryId = dialogOpenOptions.entryTypeId;
                        }
                        this._dialogOpenOptions = dialogOpenOptions;
                        if (dialogOpenOptions.openType) {
                            this._teamplateMsgSubscriptions = this._noteTemplatePageViewModel.templateMsg().pipe(
                                filter(res => !!res)
                            ).subscribe(res => this._takeTemplateMsg(res));
                            this._autoSaved = false;
                            this.titleName = dialogOpenOptions.openType;
                            if (dialogOpenOptions.isPopupEntryMode) {
                                this.titleName = NoteDialogType.CreateNote;
                                this._setPluginPageStyle();
                            }
                            this._noteAction = this._getNoteActionByOpenType(dialogOpenOptions.openType);
                            if (this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote || (this._noteAction === NoteActions.editNote && dialogOpenOptions.openType !== NoteDialogType.EditDraft) || dialogOpenOptions.intralinks) {
                                this.isHidePopOut = true;
                            }
                            // set value for side note type
                            if (this._noteAction === NoteActions.createSidenote) {
                                this._defaultSidenoteTypeId = this._dialogOpenOptions.entryTypeId;
                            }
                            if (dialogOpenOptions.blastEmail) {
                                this._createEntryId = dialogOpenOptions.entryId;
                            } else if (dialogOpenOptions.intralinks) {
                                this._intralinksData = dialogOpenOptions.intralinks;
                                // Determines whether the selected file belongs to multiple folders
                                const parentIds = new Set();
                                this._isSelectMulFolder = false;
                                this._intralinksData.forEach(item => {
                                    parentIds.add(item.parentId);
                                });
                                if (parentIds.size > 1) {
                                    this._isSelectMulFolder = true;
                                }

                            } else {
                                this.editingEntryId = dialogOpenOptions.entryId;
                            }
                            if ((dialogOpenOptions.openType === NoteDialogType.CreateNote || dialogOpenOptions.openType === NoteDialogType.EditDraft) && !dialogOpenOptions.blastEmail && !dialogOpenOptions.intralinks) {
                                this.canSaveAsDraft = true;
                            } else {
                                this.canSaveAsDraft = false;
                            }
                            if (dialogOpenOptions.isPlugInEditNoteMode) {
                                AppConfig.supportImgToStream = true;
                                this.editingEntryId = dialogOpenOptions.entryId;
                                this.isPlugInEditNoteMode = dialogOpenOptions.isPlugInEditNoteMode; // For EntryForm,office plugin Must pass it.
                                this._pluginService.isPlugInEditNoteMode = this.isPlugInEditNoteMode;
                                this._setPluginPageStyle();
                            }
                            this.isDraft = dialogOpenOptions.openType === NoteDialogType.EditDraft;
                            this._disableEntityField = !dialogOpenOptions.entityFieldEditable;
                            this._currentEntity = dialogOpenOptions.entity;
                            this._blastEmail = dialogOpenOptions.blastEmail;
                            this._initData();
                            this._initAllType();
                            this.open();
                            setTimeout(() => {
                                if (this._blastEmail) {
                                    this._onAttachmentLoaded(dialogOpenOptions.blastEmail, true);
                                } else if (this._intralinksData) {
                                    const data = { 'attachments': new Map<string, DocumentEmail>() };
                                    this._intralinksData.forEach(item => {
                                        data.attachments.set(item.id, DocumentEmail.parseForIntralinks(item));
                                    });
                                    this._onAttachmentLoaded(data, true);
                                } else {
                                    if (!this.editingEntryId) {
                                        this._onAttachmentLoaded(null, false);
                                    }
                                }
                            }, 500);
                        }
                    } else {
                        this.maxmize();
                    }
                } else {
                    // we should set note type and priority to default after changing email in pin mode
                    this.sentimentConfig = null; // to clear priority data
                    this._takeNoteType(this._noteTypeResDefault);
                }
            }),
        );

        if (!this._isOfficeAddinPinMode) {
            this._destroySubscriptions.push(
                this._noteTemplatePageViewModel.noteTypeForWeb().pipe(
                    filter(res => res != null && res.entryTypes.length > 0 && res.defaultEntryTypeId.length > 0 && !!this._dialogOpenOptions),
                ).subscribe(res => {
                    // we need to set the entry type to default when user switching email after deposit one email in pin mode. TAM-38290
                    this._noteTypeResDefault = res;
                    this._takeNoteType(res);
                }),
                this._noteTemplatePageViewModel.noteForEdit().pipe(
                    filter(res => res && res.id),
                ).subscribe(res =>
                    this._getEditData(res)),
                this._noteTemplatePageViewModel.templateValueSet().subscribe((res) => this._templateValueSet = res),
                this._noteTemplatePageViewModel.autoSave().pipe(
                    filter(res => res && res.type),
                ).subscribe(res => {
                    this._afterAutoSave(res);
                }),
                // best practice: if the selected data is directly bound to UI,
                // use map operator and bind the observable directly to UI using Angular async pipe
                this._noteTemplatePageViewModel.noteTemplateConfiguration().pipe(
                    filter(res => res != null && res.contains != null && !!this._dialogOpenOptions),
                ).subscribe(res => {
                    if (!this.isOfficeAddinMode) {
                        this._processNoteTemplateConfiguration(res);
                    } else {
                        // we need to store the latest note teamplateconfiguration each time when note type changes for office add-in
                        this._noteTemplateConfigurations = res;
                        if (this._firstOpen) {
                            // only need to get data from office when opening email for the first time
                            this._showAddInInfoOnNoteDialog(res);
                        } else {
                            this._processNoteTemplateConfiguration(res);
                        }
                    }
                }),
                // gets if privacy enabled and privacySetting for combiling privacy teams list usage.
                this._noteTemplatePageViewModel.privacyConfiguration().pipe(
                    filter(res => res != null && res.privacyEnabled != null),
                ).subscribe(res => this._takePrivacyConfiguration(res)),
                // gets privacy teams and default privcayid
                this._noteTemplatePageViewModel.privacyTeams().pipe(
                    filter(res => res != null && res.privacyTeams != null),
                ).subscribe(res => this._takePrivacyTeams(res)),
                this.noteAttachmentsConfig.feedbackSubject$.subscribe((res) => {
                    if (res && res.type === NoteAttachmentsFeedbackTypes.OnStatusChange) {
                        if (res.payload && res.payload.changedFile && res.payload.changedFile.ids && res.payload.changedFile.ids.length) {
                            if (res.payload.changedFile.isDirty) {
                                this._dirtyAttachments = this._dirtyAttachments.concat(res.payload.changedFile.ids);
                            } else {
                                this._dirtyAttachments = this._dirtyAttachments.filter((id) => !res.payload.changedFile.ids.includes(id));
                            }
                        }
                        if (res.payload && res.payload.workflow === 'upload') {
                            this.attachmentUploading = res.payload.isEditing;
                        }
                        if (res.payload && res.payload.workflow === 'rename') {
                            this.attachmentRenaming = res.payload.isEditing;
                        }
                        if (res.payload && this.canSaveAsDraft && res.payload.workflow && res.payload.isEditing === false) {
                            this._autoSavePer3(this._templateValueSet);
                        }
                        // enable the buttons of cancel/save as draft/publish when all the files have been removed in add-in mode.
                        if (AddInUtilities.isOfficeJSLoaded() && res.payload && res.payload.workflow === 'remove' && res.payload.files) {
                            if (res.payload.files.filter(f => !f.isCompleted).length === 0) {
                                this.attachmentUploading = false;
                            }
                            if (res.payload.changedFile && res.payload.changedFile.ids) {
                                this._deletedFileIds.push(res.payload.changedFile.ids[0]);
                                // stop the post http request since it has been deleted
                                this._noteDialogService.cancelRequest$.next(null);
                            }
                        }
                    }
                }),
                // note body html string subscription used in edit mode
                this._noteTemplatePageViewModel.noteBodyForEdit()
                    .subscribe((res) => this._takeNoteBodyForEdit(res)),

                // prompt info dialog before closing the plugin note dialog when plugin token is expired
                this._pluginService.pluginSubject$.subscribe(() => {
                    if (this.isPlugInEditNoteMode) {
                        const subscription = this._alertWindow.info('Your login session is expired.', ['Please click "OK" and try to deposit again.'], this._dialogOpenOptions.eventKey, this._dialogOpenOptions.eventValue).subscribe((result: boolean) => {
                            this._setDialogCloseForPlugin();
                            subscription.unsubscribe();
                        });
                    }
                }),
                this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),
                this._fileHelperService.downloadFile$.subscribe(() => { this._downloadFile = true; }),
            );
        }
    }

    ngOnDestroy() {
        document.removeEventListener('keydown', this.onDocumentEscape, true);
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
        if (this._dropzoneSubscription$) {
            this._dropzoneSubscription$.unsubscribe();
        }
        if (this.valueChangeSubscribtionForPer30 && !this.valueChangeSubscribtionForPer30.closed) {
            this.valueChangeSubscribtionForPer30.unsubscribe();
        }
        if (this.valueChangeSubscribtionForPer3 && !this.valueChangeSubscribtionForPer3.closed) {
            this.valueChangeSubscribtionForPer3.unsubscribe();
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (this.opened && !this.isPlugInEditNoteMode && !this._dialogOpenOptions.isPopupEntryMode && !this._downloadFile) {
            // don't need to pop notification when changing url for plugin.
            $event.returnValue = true;
        }
        this._downloadFile = false;
    }

    /**
    *  close task pane for office add-in
    */
    onCloseBtnClick() {
        AddInUtilities.closeTaskPaneForAddIn();
    }

    onContainerEvent(event) {
        this.viewContainer = event;
    }

    /**
     * trigger autosave before popup new entry window
     */
    popupEntry() {
        this._clickPopupEntry = true;
        this._isAutoSavingPer30 = false;
        this._isAutoSavingPer3 = false;
        this.isAutoSaving = false;
        this._clearTimer();
        this._saveAction = NoteActions.saveDraft;
        this._publishSubject$.next('');
        this._preSaveNote(true, true);
        this.publishButtonHasBeenClicked = true;
    }

    callbackPopupEntryWindow() {
        if (!this.editingEntryId) {
            this.editingEntryId = 'entry-type:' + this._noteTypeDefalult.id;
        }
        this._templateDialogService.changeValueStatus = false;
        const iTop = (window.screen.availHeight - 30 - 500) / 2;
        const iLeft = (window.screen.availWidth - 10 - this.dialogWidth) / 2;
        const width = this.dialogWidth * 1.1;
        const action = this.isDraft ? 'draft' : 'new';
        window.open(action + '/popoutentry/' + this.editingEntryId, '_blank', 'top=' + iTop + ',left=' + iLeft + ',width=' + width + ',height=700,toolbar=no, menubar=no,resizable=no, location=no, status=noï¼Œtitlebar=no');
        this.clickClose('close', null, true);
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        if (this.isPopupEntry) {
            if (e.target.innerWidth < 650) {
                window.resizeTo(this.dialogWidth * 1.1, 700);
            } else {
                this._initWidth(e.target.innerWidth);
            }
        }
    }

    private _initWidth(windowWidth: number) {
        const params = (windowWidth - 80) / (this.dialogWidth - 80);
        this.processWidth(this.tplConfig, params, windowWidth);
    }

    processWidth(config, params, windowWidth, isGroup?) {
        for (const row of config) {
            const newRow = [].concat(row);
            for (const ctrl of newRow) {
                ctrl.viewContainer = this.viewContainer;
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    this.processWidth(ctrl.contains, params, windowWidth, true);
                }
                ctrl.width = ctrl.width * params;
                if (ctrl.labelWidth) {
                    ctrl.controlWidth = ctrl.width - ctrl.labelWidth - 5;
                } else {
                    ctrl.controlWidth = ctrl.width - 5;
                }
            }
        }

        this.dialogWidth = _lodash.cloneDeep(windowWidth);
    }

    hideMetadataClick() {
        this.clickHideControl = !this.clickHideControl;
        if (this.clickHideControl) {
            this.hideControl = 'Show metadata';
        } else {
            this.hideControl = 'Hide metadata';
        }
        this._setHideControl();
    }


    private _setHideControl() {
        for (const row of this.tplConfig) {
            const newRow = row.concat();
            for (const ctrl of newRow) {
                ctrl.viewContainer = this.viewContainer;
                if (ctrl.componentType !== 'ckeditor-input') {
                    if (this.clickHideControl) {
                        ctrl.isHidden = true;
                    } else {
                        ctrl.isHidden = false;
                    }
                }
            }
        }
    }

    onCheckBoxClick() {
        this.checkboxValue = true;
        this._calendarParams = {
            openType: CalendarDialogType.NewEvent,
            isOfficeAddinMode: true,
            entity: null,
            officeAddIn: this._officeAddIn,
            minimizable: false,
            entryId: '',
            isPluginInEditEventMode: false
        };
        this.clickClose('close', null, false, false);
    }

    /**
    *  user click the cancel/click  button
    *  status : tip alertWindow or close or others
    *  [TAM-30196] New Note/Edit Draft - Popout (save as draft) -> cancel -> warning dialog * If user choose discard, Exit and delete draft
    *              If user choose Keep exit but keep draft.
    *  isClosePanel:if you need to keep panel . set
    */
    public clickClose(status: string, event: Event, isClickPopoutEntry = false, isClosePanel = true) {
        // same as footer button disable
        // New note dialog, when first auto save is running, can not close
        if (this.isAutoSaving && !this.editingEntryId) {
            return;
        }
        this._pausedAutoSave = this._clearTimer();
        // only work for addin mode.
        if (!this._autoSaved && this.checkboxValue && this.isOfficeAddinMode) {

            const cancelBtn: AlertButton = {
                text: 'Go back',
                type: AlertBtnTypes.tertiary
            };
            const confirmButton: AlertButton = {
                text: 'Confirm',
                type: AlertBtnTypes.primary
            };

            const subscription = this._alertWindow.
                custom('Confirmation required', ['Please confirm to save it as event.'], cancelBtn, confirmButton)
                .subscribe((result: boolean) => {
                    if (result) {
                        this.close();
                        this._clearData();
                        this._calendarParams.triggerSource = CalendarDialogTriggerSource.NoteDialog;
                        this._calendarDialogService.dialogOpen$.next(this._calendarParams);
                    } else {
                        this.checkboxValue = false;
                    }
                    subscription.unsubscribe();
                });

            return;
        }

        if (!this._templateDialogService.changeValueStatus && this._dirtyAttachments.length === 0 && !this.attachmentUploading && !this.isPopupEntry && !this._autoSaved) {
            this._deleteDraftInPluginEditMode();
            if (!this._dialogOpenOptions.isPopupEntryMode || this._popoutDraft) {
                this.close();
                this._clearData();
                if (isClosePanel) {
                    AddInUtilities.closeTaskPaneForAddIn();
                }
            }
        } else if (!this._templateDialogService.changeValueStatus && !this.attachmentUploading && (isClickPopoutEntry || !this._autoSaved)) {
            this.close();
            this._clearData();
        } else if (this._autoSaved && (this._dialogOpenOptions.openType === NoteDialogType.CreateNote || (this._dialogOpenOptions.openType === NoteDialogType.EditDraft && this._dialogOpenOptions.isPopupEntryMode && !this._popoutDraft)) && this.editingEntryId) {
            const subscription = this._alertWindow.confirm('You have an autosaved draft associated',
                ['Would you like to keep the draft?'], 'Discard', 'Keep', this._dialogOpenOptions.eventKey, this._dialogOpenOptions.eventValue, this.isOfficeAddinMode ? AlertViewType.COMPACT : AlertViewType.NORMAL).subscribe((result: boolean) => {
                    if (result === true) {
                        this._store.dispatch({
                            type: DELETE_AUTOSAVED_DRAFT,
                            payload: {
                                id: this.editingEntryId,
                                componentId: 'Note Dialog',
                                draft: true,
                            }
                        });

                        if (this.checkboxValue) {
                            this.close();
                            this._clearData();
                            this._calendarDialogService.dialogOpen$.next(this._calendarParams);
                        }
                    } else if (result === null) {
                        // toast successful message
                        this._infoToast.message = StringLiteralsPipe.translate('note.draft_successfully_created');
                        this._infoToast.style = NotificationStyles.Success;
                        if (!this.isOfficeAddinMode) {
                            this._toast.notify(this._infoToast);
                        }
                        // If user keep the draft, refresh draft list
                        this._draftService.actionSubject$.next({ type: DraftActionType.RELOAD, payload: null });

                        if (this.checkboxValue) {
                            this._calendarDialogService.dialogOpen$.next(this._calendarParams);
                        } else {
                            if (this.isOfficeAddinMode) {

                                const noteState = this._storeQuerier.queryBySelector(getNoteSelector);
                                if (noteState) {
                                    this._addinEntryId = noteState.entry.id;
                                    this.addinSubject = noteState.entry.calculatedTitle;
                                }
                                this.addinSuccessTip = StringLiteralsPipe.translate('addin.draft_successfully_created');
                                this.isDialogHidden = true;
                            }
                        }
                        if (!this.isOfficeAddinMode || (this.isOfficeAddinMode && this.checkboxValue)) {
                            // If this is addin mode and display note dialog ,shouldn't close dialog.
                            // If change to event dialog should be close note dialog.
                            this.close();
                            this._clearData();
                        }
                    } else {
                        this.checkboxValue = false;
                        if (this._pausedAutoSave) {
                            this._pausedAutoSave = false;
                            this._isAutoSavingPer30 = false;
                            this._isAutoSavingPer3 = false;
                            this.isAutoSaving = false;
                            this._autoSavePer30(this._templateValueSet);
                        }
                    }
                    subscription.unsubscribe();
                });
        } else {
            const uploading = this._processingUploads.length && this._processingUploads.reduce((result, item) => result || item.status === 0, false);
            const warningText = 'Are you sure you want to ' + (uploading ? 'cancel file uploading and ' : '') + 'discard all your changes?';
            const subscription = this._alertWindow.warn('You have unsaved changes', [warningText], 'Discard', 'Go Back', this._dialogOpenOptions.eventKey, this._dialogOpenOptions.eventValue).subscribe((result: boolean) => {
                if (result) {
                    if (this.isOfficeAddinMode) {
                        // if check switch to event dialog.
                        if (this.checkboxValue) {
                            this.close();
                            this._clearData();
                            this._calendarDialogService.dialogOpen$.next(this._calendarParams);
                            return;
                        }
                        if (this._isOfficeAddinPinMode) {
                            // need to reset data for note dialog in this case
                            this._firstOpen = true;
                            this._officeAddIn = this._officeAddInOld;
                            this._zone.run(() => {
                                this._processNoteTemplateConfiguration(this._noteTemplateConfigurations);
                                this._onAttachmentLoaded(this._officeAddIn, false, true);
                            });
                        }
                        if (isClosePanel) {
                            // for word addin, we need to close the note dialog when user clicks cancel and then discard although the task pane could not be closed.
                            this.close();
                            this._clearData();
                            AddInUtilities.closeTaskPaneForAddIn();
                        }
                    } else {
                        this._deleteDraftInPluginEditMode();
                        const action = new NoteAttachmentsAction();
                        action.type = NoteAttachmentsActionTypes.DeleteAttachments;
                        action.payload = {
                            workflow: 'cancel',
                            callback: (files) => {
                                if (!this.isPlugInEditNoteMode) {
                                    this.close();
                                    this._clearData();
                                }
                            }
                        };
                        this.noteAttachmentsConfig.actionSubject$.next(action);
                    }
                } else {
                    if (this._pausedAutoSave) {
                        this._pausedAutoSave = false;
                        this._isAutoSavingPer30 = false;
                        this._isAutoSavingPer3 = false;
                        this.isAutoSaving = false;
                        this._autoSavePer30(this._templateValueSet);
                    }
                }
                subscription.unsubscribe();
            });
        }
        // make publish button work after close dialog
        this.publishButtonHasBeenClicked = false;
        if (event) {
            event.stopImmediatePropagation();
        }
    }

    public handleFilter(value, dropDownEl) {
        this._noteTypes = [];
        if (!value) {
            this._noteTypes = this._noteTypesSource;
        } else {
            this._noteTypes = this._noteTypesSource.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
            if (this._noteTypes.length >= 1) {
                setTimeout(() => {
                    dropDownEl.optionsList.content.nativeElement.scrollTop = 0;
                });
            }
        }
    }

    onDocumentEscape = (event: KeyboardEvent) => {
        if (event.key !== 'Escape' && event.key !== 'Esc') { return; }
        if (!this.opened) { return; }
        // Check for open Kendo dropdowns/multiselects/datepickers
        const hasOpenKendoPopup = !!document.querySelector(
            'kendo-dropdownlist[aria-expanded="true"], input.k-input-inner[aria-expanded="true"]'
        );
        if (hasOpenKendoPopup) { return; }
        // Check for open alert dialogs - let them handle ESC first
        const hasOpenAlertDialog = !!document.querySelector('.alert-window-container');
        if (hasOpenAlertDialog) { return; }
        event.stopImmediatePropagation();
        this._zone.run(() => this.clickClose('close', null));
    };

    // the keydown event should not be propagated to parent window
    @HostListener('keydown', ['$event'])
    handleKeydown(event: KeyboardEvent) {
        event.stopPropagation();
    }

    keySend(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            this.publish();
        }
    }

    /**
     * dialog maxmize
     */
    public maxmize() {
        this.dialogConfig.actionSubject$.next({ type: DialogAction.MAXIMIZE });
        this._noteDialogService.minimized = false;
    }

    /**
     * close dialog min
     */
    public closemin() {
        this.maxmize();
        this.clickClose('close', null);
    }

    /**
     * dialog open
     */
    public open() {
        // Add class "threaddetail-sidesheet-status" to display side sheet when open note dialog
        if (this._el.querySelector('.note_dialog')) {
            if (!this._el.querySelector('.threaddetail-sidesheet-status')) {
                this.renderer.addClass(this._el.querySelector('.note_dialog'), 'threaddetail-sidesheet-status');
            }
        }

        this.opened = true;
        this._noteDialogService.opened = true;
    }

    /**
     * click esc close dialog but if kendo dropdown is open .close dropdown first
     *
     * @param {*} event
     * @returns
     * @memberof NoteDialogComponent
     */
    public onEnter(event) {
        let el = event.target;
        const parentArray = [];
        while (el && el.nodeName !== 'BODY' && el.parentNode) {
            el = el.parentNode;
            if (el) {
                parentArray.push(el.nodeName);
            }
        }
        if (parentArray.indexOf('KENDO-POPUP') !== -1) {
            return;
        }
        if (this.opened) {
            this.clickClose('close', null);
        }
    }

    public onCancelBtnClick(event: Event) {
        // thread detail side sheet should not be hideen when clicking the alert window
        this._alertWindow.openForSideSheet$.next('');

        this.clickClose('cancel', event);
        // make button work after click cancle button
        this.publishButtonHasBeenClicked = false;
    }

    onClickSetEventValue(e: Event) {
        if (this._dialogOpenOptions && this._dialogOpenOptions.eventKey) {
            e[this._dialogOpenOptions.eventKey] = this._dialogOpenOptions.eventValue;
        }
    }

    onClickReload() {
        const noteDialogOpenOptions = _lodash.cloneDeep(this._dialogOpenOptions);
        if (this._entry && this._entry.id) {
            noteDialogOpenOptions.entryId = _lodash.cloneDeep(this._entry.id);
            if (this._dialogOpenOptions.openType === NoteDialogType.CreateNote) {
                this._dialogOpenOptions.openType = NoteDialogType.EditDraft;
                noteDialogOpenOptions.entityFieldEditable = true;
            }
        }
        noteDialogOpenOptions.openType = _lodash.cloneDeep(this._dialogOpenOptions.openType);
        noteDialogOpenOptions.entryTypeId = this._notifyAction.payload.id;
        noteDialogOpenOptions.minimizable = true;
        this.opened = false;
        this._clearData();
        this._noteAction = null;
        setTimeout(() => {
            this._noteDialogService.dialogOpen$.next(noteDialogOpenOptions);
        }, 0);
    }

    /**
     * open a default browser to show entry detail
     */
    onSubjectClick() {
        if (AddInUtilities.isOfficeEnvironment()) {
            const win = this._winRef.nativeWindow;
            if (win && win.location.href && this._addinEntryId) {
                const noteLink = win.location.origin + '/tamaleweb/entry/' + this._addinEntryId;
                // open a default web browser, not a browser embedded in office
                if (Office.context.ui.openBrowserWindow) {
                    // app email
                    Office.context.ui.openBrowserWindow(noteLink);
                } else {
                    // web email
                    window.open(noteLink, '_blank');
                }
            }
        }
    }

    public privacyChanged(data) {
        this._privacyTeam = data;
    }

    public privacyHandleFilter(value) {
        this._privacyList = this._privacyListSource.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public publish() {
        this._isAutoSavingPer30 = false;
        this._isAutoSavingPer3 = false;
        this.isAutoSaving = false;
        this._clearTimer();
        this._saveAction = NoteActions.saveNote;
        if (this._intralinksData) {
            this.windowMinimize();
            this._intralinksValidationService.validate(this._intralinksData[0].screenId, this._intralinksData[0].workspaceId).pipe(take(1)).subscribe((result) => {
                if (result) {
                    this.publishButtonHasBeenClicked = true;
                    this._preSaveNote(false);
                } else {
                    this.maxmize();
                }
            });
        } else {
            this.publishButtonHasBeenClicked = true;
            this._preSaveNote(false);
        }
        this._publishSubject$.next('');
    }

    public selectionChange(value: any): void {
        this._isTriggerAutoSave = true;
        this._accumulateTemplateValueSetChanges(); // save the previous template when switching note types
        this._noteTypeChanged(value.id);
        this.isNeedReload = false;
    }

    public saveAsDraft() {
        this._isAutoSavingPer30 = false;
        this._isAutoSavingPer3 = false;
        this.isAutoSaving = false;
        this._clearTimer();
        this._saveAction = NoteActions.saveDraft;
        this._publishSubject$.next('');
        this._preSaveNote(true);
        this.publishButtonHasBeenClicked = true;
    }

    /**
    * click the  minimize button .appear the minimize window
    */
    public windowMinimize() {
        this.dialogConfig.actionSubject$.next({ type: DialogAction.MINIMIZE });
        this._noteDialogService.minimized = true;
    }

    /********** private function **********/

    private _afterAutoSave(res) {
        if (res.type === AUTO_CREATE_DRAFT_SUCCESS) {
            this.editingEntryId = res.payload.id;
        }
        this._isAutoSavingPer30 = false;
        this._isAutoSavingPer3 = false;
        this.isAutoSaving = false;
        if (res.type === AUTO_CREATE_DRAFT_FAILURE || res.type === AUTO_UPDATE_DRAFT_FAILURE) {
            this._autoSavePer30('');
        } else {
            this._autoSaved = true;
            this.autoSaveTime = new Date(res.payload.entry.lastEditDate);
            // assign value for entities
            if (this._isNEREntryType() && !this._templateValueSet['ENTITIES'].isHidden) {
                if (this.opened) {
                    if (res && res.payload && res.payload.entry) {
                        this._autoTagEntities = [];
                        // get all return entities
                        const returnEntities = res.payload.entry.entities;

                        // get auto tag entities
                        if (returnEntities) {
                            returnEntities.forEach(entity => {
                                if (entity.confidence) {
                                    if (!this._autoTagEntities.find(item => item.id === entity.id)) {
                                        this._autoTagEntities.push(entity);
                                    }
                                }
                            });
                        }

                        // triger auto tag
                        if (returnEntities.length > 0) {
                            if (returnEntities.length === 1 &&
                                (returnEntities[0] === businessConstants.entity.Uncategorized_Fixed_ID
                                    || returnEntities[0] === this._unCategorizedId)) {
                                this.autoTagSubject.next({
                                    type: 'TriggerByAutoSave',
                                    payload: {
                                        returnEntities: [],
                                        autoTagEntities: []
                                    }
                                });
                                if (this._clickPopupEntry) {
                                    this.callbackPopupEntryWindow();
                                }
                                return;
                            } else {
                                this.autoTagSubject.next({
                                    type: 'TriggerByAutoSave',
                                    payload: {
                                        returnEntities: returnEntities,
                                        autoTagEntities: this._autoTagEntities
                                    }
                                });
                            }
                        }
                    }
                }
            }
        }
        if (this._clickPopupEntry) {
            this.callbackPopupEntryWindow();
        }
    }

    private _autoSavePer30(data) {
        if (this._isAutoSavingPer30) {
            return;
        }
        this._isAutoSavingPer30 = true;
        if (this._autoSaveTimerPer30) {
            clearTimeout(this._autoSaveTimerPer30);
            this._autoSaveTimerPer30 = null;
        }
        this._autoSaveTimerPer30 = setTimeout(() => {
            if (this.opened && !this.isAutoSaving) {
                this.isAutoSaving = true;
                this._clearTimer();
                this._saveAction = NoteActions.saveDraft;
                this._preSaveNote(true, true);
            }
        }, AUTO_SAVE_INTERVAL_30);
    }

    private _autoSavePer3(data) {
        if (this._isAutoSavingPer3) {
            return;
        }
        if (this._autoSaveTimerPer3) {
            clearTimeout(this._autoSaveTimerPer3);
            this._autoSaveTimerPer3 = null;
        }
        this._autoSaveTimerPer3 = setTimeout(() => {
            if (this.opened && !this.isAutoSaving) {
                this.isAutoSaving = true;
                this._isAutoSavingPer3 = true;
                this._clearTimer();
                this._saveAction = NoteActions.saveDraft;
                this._preSaveNote(true, true);
            }
        }, AUTO_SAVE_INTERVAL_3);
    }

    private _accumulateTemplateValueSetChanges() {
        // this._previousTemplateValueSet = {};
        // tslint:disable-next-line: forin
        for (const controlId in this._templateValueSet) {
            const ctrl = this._templateValueSet[controlId];
            let adhocId;
            const adhocDefId = ctrl.adhocDefId.toString();
            if (adhocDefId.indexOf('x-') > -1) {
                adhocId = adhocDefId.slice(2).toLowerCase();
            } else {
                adhocId = adhocDefId.toLowerCase();
            }
            if (this._previousTemplateValueSet[adhocId] == null) {
                this._previousTemplateValueSet[adhocId] = {};
            }
            if (ctrl.componentType === 'ckeditor-input' && this._templateValueSet[controlId].isEntryForm && this._noteAction !== NoteActions.createSidenote && this._noteAction !== NoteActions.editSidenote) {
                this._previousTemplateValueSet[adhocId][ctrl.componentType] = '';
                continue;
            } else {
                this._previousTemplateValueSet[adhocId][ctrl.componentType] = this._templateValueSet[controlId];
            }
        }
    }

    private _bindDefaultNoteType(entryTypeList: Array<EntryType>, noteTypeId: string) {
        if (entryTypeList && entryTypeList.length > 0) {
            const typeList = entryTypeList.filter(item => item.id.toString() === noteTypeId);
            if (typeList && typeList.length > 0) {
                this._noteTypeDefalult.id = typeList[0].id;
                this._noteTypeDefalult.name = typeList[0].name;
                this._noteTypeChanged(noteTypeId);
            }
        }
    }

    private _clearData() {
        this._noteTypes = null;
        this._noteTypesSource = null;
        this._noteTypeDefalult = null;
        this.privacyListDefalult = null;
        this._privacyList = null;
        this._firstOpen = true;
        this._previousTemplateValueSet = {};
        this._createEntryId = '';
        this.editingEntryId = '';
        this._dialogOpenOptions = null;
        this._templateDialogService.changeValueStatus = false;
        this._dirtyAttachments = [];
        this._isAutoSavingPer30 = false;
        this._isAutoSavingPer3 = false;
        this.isAutoSaving = false;
        this._autoSaved = false;
        this.isPrivacy = false;
        this._clearTimer();
        this.autoSaveTime = null;
        this.isDraft = false;
        this._newEntitiesFieldValue = [];
        this._blastEmail = null;
        this._clickPopupEntry = false;
        this.isHidePopOut = false;
        this._intralinksData = null;
        this._entry = null;
        this.isNeedReload = false;

        // office add-in
        this.addinSubject = '';
        this.isDialogHidden = false;
        this.isShowBtnClose = true;

        this._addinEntryId = '';
        this._noteTemplateConfigurations = null;
        this._officeAddIn = null;
        this._officeAddInOld = null;
        this._defaultSidenoteTypeId = '';
        this.checkboxValue = false;
        this.isDialogHidden = false;
    }

    private _clearTimer(): boolean {
        let result = false;
        if (this._autoSaveTimerPer30) {
            clearTimeout(this._autoSaveTimerPer30);
            this._autoSaveTimerPer30 = null;
            result = true;
        }
        if (this._autoSaveTimerPer3) {
            clearTimeout(this._autoSaveTimerPer3);
            this._autoSaveTimerPer3 = null;
            result = true;
        }
        return result;
    }

    private _createNoteInitialization() {
        this._noteTemplatePageViewModel.getNoteTypes();
        this._noteTemplatePageViewModel.getPrivacyConfiguration(AppConfig.privacyConfiguration);
    }

    private _deleteDraftInPluginEditMode() {
        if (this.isPlugInEditNoteMode || this._dialogOpenOptions.isPopupEntryMode && !this._popoutDraft) {
            this._store.dispatch({
                type: DELETE_AUTOSAVED_DRAFT,
                payload: {
                    id: this.editingEntryId,
                    componentId: 'Note Dialog',
                    draft: true,
                }
            });
        }
    }

    private _editNoteInitialization() {
        this._noteTemplatePageViewModel.getNoteTypes(this.editingEntryId);
        if (this.isDraft) {
            this._noteTemplatePageViewModel.getPrivacyConfiguration(AppConfig.privacyConfiguration);
        }
        this._noteBodyOnEdit();
    }

    private _getNoteActionByOpenType(openType: string) {
        switch (openType) {
            case NoteDialogType.CreateNote:
                return NoteActions.createNote;
            case NoteDialogType.EditNote:
            case NoteDialogType.EditDraft:
                return NoteActions.editNote;
            case NoteDialogType.AddSideNote:
                return NoteActions.createSidenote;
            case NoteDialogType.EditSideNote:
                return NoteActions.editSidenote;
            default:
                return NoteActions.createNote;
        }
    }

    private _initData() {
        this.dialogWidth = 684;
        this.domainUrl = window.location.host;
        this._noteTypesSource = new Array<EntryType>();
        this._noteTypeDefalult = new EntryType();
        this.privacyListDefalult = new Array<any>();
        this._privacyList = new Array<any>();
        this.tplConfig = [];
        this.publishButtonHasBeenClicked = false;
    }

    /**
     * Initialization based on different actions
     */
    private _initAllType() {
        switch (this._noteAction) {
            case NoteActions.createNote:
                this._createNoteInitialization();
                break;
            case NoteActions.editNote:
                if (this.editingEntryId != null && this.editingEntryId.length > 0) {
                    this._editNoteInitialization();
                }
                break;
            case NoteActions.createSidenote:
            case NoteActions.editSidenote:
                if (this.editingEntryId != null && this.editingEntryId.length > 0) {
                    this._editNoteInitialization();
                }
                break;
            default:
                break;
        }
    }

    private _initDefaultNoteType(res) {
        const data = res.entryTypes;
        this._isTriggerAutoSave = false;
        this._noteTypeDefalult = new EntryType();
        // if edit note but this entry type is no-exist in entry type list or set hide in note model。
        if (this._defaultSidenoteTypeId) {
            // exsit entry type in list (new or edit)
            for (const index in data) {
                if (data[index].id.toString() === this._defaultSidenoteTypeId) {
                    this._noteTypeDefalult.id = data[index].id;
                    this._noteTypeDefalult.name = data[index].name;
                    this._noteTypeChanged(this._defaultSidenoteTypeId);
                    break;
                }
            }
        } else {
            // if edit note but this entry type is no-exist in entry type list or set hide in note model
            if (res.defaultEntryTypeId && res.defaultEntryTypeName) {
                this._noteTypeDefalult.id = res.defaultEntryTypeId;
                this._noteTypeDefalult.name = res.defaultEntryTypeName;
                this._noteTypeChanged(this._noteTypeId);
            } else {
                // exsit entry type in list (new or edit)
                if (AddInUtilities.isOfficeEnvironment()) {
                    if (res.entryTypes && res.entryTypes.length > 0) {
                        const addInDefaultEntryType = this._getAddInDefaultEntryType(data);
                        if (addInDefaultEntryType && addInDefaultEntryType.length > 0) {
                            this._noteTypeId = this._noteTypeDefalult.id = addInDefaultEntryType[0].id;
                            this._noteTypeDefalult.name = addInDefaultEntryType[0].name;
                            this._noteTypeChanged(this._noteTypeId);
                        } else {
                            this._bindDefaultNoteType(data, this._noteTypeId);
                        }
                    }
                } else {
                    this._bindDefaultNoteType(data, this._noteTypeId);
                }
            }
        }
    }

    /**
     * According to PM's requirement, we need to keep the logic the same as what it did in rich client. filter by id first, then by name.
     * @param entryTypeList
     * @returns
     */
    private _getAddInDefaultEntryType(entryTypeList: Array<EntryType>): Array<EntryType> {
        let eTypeList: Array<EntryType> = [];
        switch (Office.context.host.toString()) {
            case AddInType.OUTLOOK:
                eTypeList = entryTypeList.filter(item => item && item.id === webBusinessConstants.officeAddIn.defaultNoteType.EMAIL_TYPEID);
                if (eTypeList.length === 0) {
                    eTypeList = entryTypeList.filter(item => item && item.name === webBusinessConstants.officeAddIn.defaultNoteType.EMAIL);
                }
                return eTypeList;
            case AddInType.WORD:
                eTypeList = entryTypeList.filter(item => item && item.id === webBusinessConstants.officeAddIn.defaultNoteType.REPORT_TYPEID);
                if (eTypeList.length === 0) {
                    eTypeList = entryTypeList.filter(item => item && item.name === webBusinessConstants.officeAddIn.defaultNoteType.REPORT);
                }
                return eTypeList;
            case AddInType.EXCEL:
                eTypeList = entryTypeList.filter(item => item && item.id === webBusinessConstants.officeAddIn.defaultNoteType.MODEL_TYPEID);
                if (eTypeList.length === 0) {
                    eTypeList = entryTypeList.filter(item => item && item.name === webBusinessConstants.officeAddIn.defaultNoteType.MODEL);
                }
                return eTypeList;
            case AddInType.POWERPOINT:
                eTypeList = entryTypeList.filter(item => item && item.id === webBusinessConstants.officeAddIn.defaultNoteType.PRESENTATION_TYPEID);
                if (eTypeList.length === 0) {
                    eTypeList = entryTypeList.filter(item => item && item.name === webBusinessConstants.officeAddIn.defaultNoteType.PRESENTATION);
                }
                return eTypeList;
            default:
                return eTypeList;
        }
    }

    private _initAutoSave() {
        if (this.canSaveAsDraft) {
            this.valueChangeSubscribtionForPer30 = this.valueChangeSubject.pipe(
                filter(data => data.isFromUser),
            ).subscribe(data => {
                this._autoSavePer30(data);
            });
            this.valueChangeSubscribtionForPer3 = this.valueChangeSubject.pipe(
                filter(data => data.isFromUser),
                debounceTime(1000),
            ).subscribe(data => {
                this._autoSavePer3(data);
            });
            if (this._isTriggerAutoSave) {
                this._isTriggerAutoSave = false;
                this._autoSavePer3(null);
            }
        }
    }

    private _isNEREntryType() {
        let _isNEREntryType = false;
        for (const index in this._noteTypes) {
            if (this._noteTypes[index].id.toString() === this._noteTypeId) {
                if (this._noteTypes[index].useNER) {
                    _isNEREntryType = true;
                }
                break;
            }
        }
        return _isNEREntryType;
    }

    private _initOfficeAddIn(dialogOpenOptions: NoteDialogOpenOptions) {
        if (dialogOpenOptions.isOfficeAddinMode) {
            this.isOutlookAddinMode = this._noteDialogService.isOutlookAddinMode();
            this.isOfficeAddinMode = dialogOpenOptions.isOfficeAddinMode;
            this._officeAddIn = dialogOpenOptions.officeAddIn;
            this._isOfficeAddinPinMode = this._officeAddIn.isPinMode;
            this._firstOpen = true;
            this._deletedFileIds = [];

            this.editingEntryId = '';
            this.isDialogHidden = false;
            this.isSingleTemplate = true;
            this.publishButtonHasBeenClicked = false;
            this.checkboxValue = false;
            this._setPluginPageStyle();
            // pin mode can't clear data,but still need
            if (this.isOfficeAddinMode && this._isOfficeAddinPinMode) {
                this.isDialogHidden = false;
                this._templateDialogService.changeValueStatus = false;
            }
        }
    }

    /**
     * edit note
     *
     * @private
     * @param {*} res
     * @memberof NoteDialogComponent
     */
    private _getEditData(res) {
        this._entry = res;
        if (Object.keys(res) && Object.keys(res).length > 0 && !!this._dialogOpenOptions && this._noteAction !== NoteActions.createNote) {
            this._onAttachmentLoaded(res.attachments, false);
        }
    }


    /**
     * recive server notification and reopen entity dialog.
     * @param action
     */
    private _onMessageAction(action) {
        if (action.type === MessageType.ENTRY_TEMPLATE && action.payload.id === this._noteTypeId && this.opened) {
            this._notifyAction = action;
            this.isNeedReload = true;
        }
    }

    private _noteTypeChanged(id) {
        this._noteTypeId = id.toString();
        this._noteTemplatePageViewModel.getNoteTemplateConfiguration(id);
    }

    private _noteBodyOnEdit() {
        this._noteBodySubject.next({ type: NOTE_BODY_ENTER_EDITING });
    }

    private _processingDataFromJson(config: any) {
        this.tplConfig = [];
        for (const row of config) {
            const newRow = row.concat();
            for (const ctrl of newRow) {
                ctrl['prefixId'] = '';
                ctrl.viewContainer = this.viewContainer;
                ctrl.width = Math.floor(ctrl.width * this._widthFactor);
                if (ctrl.componentType === 'entity-input' && this._currentEntity) {
                    // set entity id and entity
                    ctrl.staticDefaultValue = this._currentEntity.id;
                    ctrl.staticDefaultObject = this._currentEntity;

                } else if (ctrl.componentType === 'ckeditor-input') {
                    ctrl.entryId = this.editingEntryId;
                    ctrl.noteTypeId = this._noteTypeId;
                    ctrl.isPlugInEditNoteMode = this.isPlugInEditNoteMode; // EntryForm needs it.
                    ctrl.totalHeight = this.totalHeight;
                }
                ctrl.noteAction = this._noteAction;
                if (ctrl.labelWidth > 0) {
                    ctrl.labelWidth = Math.floor(ctrl.labelWidth * this._widthFactor);
                    ctrl['controlWidth'] = ctrl.width - ctrl.labelWidth - 5;
                } else {
                    ctrl['controlWidth'] = ctrl.width - 5;
                }
                ctrl['widthFactor'] = this._widthFactor;
            }
            this.tplConfig.push(newRow);
        }
        if (this.isSingleTemplate) {
            this.singleLayerConfig = [];
            this._processTemplateForSingleLayer(this.tplConfig);
        }
        return this.tplConfig;
    }

    /**
     *
     * set layout with single layer and responsive.
     * @private
     * @param {*} config
     * @memberof NoteDialogComponent
     */
    private _processTemplateForSingleLayer(config) {
        config.forEach(verticalItems => {
            verticalItems.isVerticalTemplate = true;
            verticalItems.forEach(ctrl => {
                ctrl.isVerticalTemplate = true;
                // responsive layout
                ctrl.width = '100%';
                ctrl.labelWidth = '100%';
                ctrl.controlWidth = '100%';
                // frist layer group should set individual style.
                if (ctrl.componentType === 'group') {
                    ctrl.isFirstLayer = true;
                }
                // priority move to header.
                if (ctrl.componentType === 'priority-input') {
                    this.sentimentConfig = ctrl;
                } else {
                    // set all template control an exclusive line.
                    this.singleLayerConfig.push(ctrl);
                }
            });
        });
    }

    private _processNoteTemplateConfiguration(config: any) {
        const id = this._storeQuerier.queryBySelector(unCategorizedId);
        if (id) {
            this._unCategorizedId = id;
        }
        this._widthFactor = 1.2;
        const target = _lodash.cloneDeep(config);
        this.totalHeight = config.height;
        if (this.isPlugInEditNoteMode) {
            this.dialogWidthForPlugin = Math.floor(target.width * this._widthFactor) + 80;
            this.dialogWidth = this.dialogWidthForPlugin;
        } else {
            const windowWidth = window.innerWidth - 80;
            if (config.width * this._widthFactor > windowWidth || this.isPopupEntry) {
                this._widthFactor = windowWidth / config.width;
            }
            this.dialogWidth = Math.floor(target.width * this._widthFactor) + 80;
        }

        this._noteTemplatePageViewModel.cleanTemplateValueSet();
        this.valueChangeSubject = new ReplaySubject<any>(10);
        if (this.valueChangeSubscribtionForPer30 && !this.valueChangeSubscribtionForPer30.closed) {
            this.valueChangeSubscribtionForPer30.unsubscribe();
        }
        if (this.valueChangeSubscribtionForPer3 && !this.valueChangeSubscribtionForPer3.closed) {
            this.valueChangeSubscribtionForPer3.unsubscribe();
        }
        this._initAutoSave();
        switch (this._noteAction) {
            case NoteActions.createNote:
                this._findFirstControl = false;
                // we need to show new email data when switching emails in pin mode of office add-in
                if (this._firstOpen) {
                    this._firstOpen = false;
                    return Array.from(this._setStaticDefaultValueForCreate(this._processingDataFromJson(target.contains)));
                } else {
                    return Array.from(this._setStaticDefaultValueForNoteTypeSwitching(this._processingDataFromJson(target.contains)));
                }
            case NoteActions.editNote:
            case NoteActions.createSidenote:
            case NoteActions.editSidenote:
                this._findFirstControl = false;
                if (this.editingEntryId && this.editingEntryId.length > 0) {
                    if (this._firstOpen) {
                        this._firstOpen = false;
                        if (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.editSidenote) {
                            this._noteTemplatePageViewModel.getNoteBodyForEdit(this.editingEntryId);
                        } else if (this._noteAction === NoteActions.createSidenote) {
                            this._entry.priority = 0;
                            this._entry.sentiment = 0;
                            this._entry.source = null;
                        }
                        return Array.from(this._setStaticDefaultValueForEdit(this._processingDataFromJson(target.contains)));
                    } else {
                        return Array.from(this._setStaticDefaultValueForNoteTypeSwitching(this._processingDataFromJson(target.contains)));
                    }
                } else {
                    return config.contains;
                }
            default:
                return config.contains;
        }
    }

    private _preSaveNote(draftFlag: boolean, auto: boolean = false) {
        let valueSet = _lodash.cloneDeep(this._templateValueSet);
        valueSet = this._templateService.processStandardFields(valueSet);
        valueSet = this._templateService.processSaveActionsForWeb(valueSet, this._privacyTeam, false, this._noteAction, this._saveAction);
        // Added this condition to handle the auto-category only for TamaleWeb
        if (auto || this._saveAction === NoteActions.saveDraft) {
            if (this._isNEREntryType() && !valueSet['ENTITIES'].isHidden) {
                // set the required as false for entity field
                valueSet[StandardControlIds.entity].isRequired = false;

                // get removed entities from store
                let removedEntities = [];
                const removedEntitiesSavedInStore = this._storeQuerier.queryBySelector('removeEntities');
                if (removedEntitiesSavedInStore && removedEntitiesSavedInStore.length > 0) {
                    removedEntities = removedEntities.concat(removedEntitiesSavedInStore);
                }

                // get current entities
                let currentEntities = [];
                if (valueSet[StandardControlIds.entity].actualValue &&
                    valueSet[StandardControlIds.entity].actualValue.length > 0) {
                    currentEntities = valueSet[StandardControlIds.entity].actualValue;
                }

                // get remove entities
                this._autoTagEntities.forEach(item => {
                    const id = item.id || item;
                    if (currentEntities.length > 0) {
                        const entity = currentEntities.filter(ent => ent.id === id);
                        if (entity.length === 0) {
                            removedEntities.push(id);
                        }
                    } else {
                        if (id !== businessConstants.entity.Uncategorized_Fixed_ID) {
                            removedEntities.push(id);
                        }
                    }
                });

                // remove the entity from removedEntities if it's added back
                currentEntities.forEach(item => {
                    const index = removedEntities.indexOf(item.id);
                    if (index >= 0) {
                        removedEntities.splice(index, 1);
                    }
                });

                // save the remove entities to store
                this._store.dispatch({
                    type: REMOVE_ENTITIES,
                    payload: removedEntities
                });

                // send the remove entities to server
                if (removedEntities) {
                    valueSet['removedentities'] = removedEntities.join(',');
                }

                // set the entities which doesn't include auto tag entities
                if (this._autoTagEntities.length > 0) {
                    const entities = [];
                    const entitiesSet = new Array<BriefObject>();
                    if (valueSet[StandardControlIds.entity].actualValue &&
                        valueSet[StandardControlIds.entity].actualValue.length > 0) {
                        valueSet[StandardControlIds.entity].actualValue.forEach(entityBrief => {
                            const entity = this._autoTagEntities.filter(item => item.id === entityBrief.id);
                            if (entity.length === 0) {
                                entities.push(entityBrief['id']);
                                entitiesSet.push(entityBrief);
                            }
                        });
                        valueSet[StandardControlIds.entity].value = entities.join(';');
                        valueSet[StandardControlIds.entity].actualValue = entitiesSet;
                    }
                }
            }
        }

        const emptyFields = this._templateService.checkRequiredFields(valueSet, draftFlag);
        if (emptyFields.length > 0) {
            let msg = '';
            const msgArr = [];
            // if the alert  window show, the button will work
            this.publishButtonHasBeenClicked = false;
            for (let emptyField of emptyFields) {
                emptyField = emptyField.trim();
                if (emptyField.lastIndexOf(':') === emptyField.length - 1) {
                    emptyField = emptyField.substring(0, emptyField.length - 1);
                }
                msgArr.push(emptyField);
                msg = msgArr.join(',');
            }
            if (this._noteDialogService.minimized === true) {
                this.maxmize();
            }
            const subscription = this._alertWindow.error('Required data',
                ['Please enter the information for the required fields:', msg], this._dialogOpenOptions.eventKey, this._dialogOpenOptions.eventValue).subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
        } else if (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote) {
            // if it is creating sidenote, validate if the entities have been changed
            this._validateEntityChangesForSidenote(valueSet, draftFlag, auto);
        } else {
            this._saveNote(valueSet, draftFlag, auto);
        }
    }

    private _updateThreadEntity(): { parentNoteId: string, entityIds: Array<string> } {
        const result: { parentNoteId: string, entityIds: Array<string> } = {
            parentNoteId: null,
            entityIds: null,
        };
        if ((this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote) &&
            this._newEntitiesFieldValue.length > 0) {
            result.parentNoteId = this._entry.threadId;
            result.entityIds = this._newEntitiesFieldValue;
            return result;
        } else {
            return null;
        }
    }

    private _saveNote(valueSet, draftFlag: boolean, auto: boolean = false) {
        if (this._saveAction !== NoteActions.saveDraft) {
            valueSet = this._templateService.appendPrivacyTeamToEntitiesForWeb(valueSet, this._privacyTeam);
        }
        const subject = this._formulaService.handleSubjectByFormula(valueSet);
        if (subject !== null && subject !== undefined && subject !== '') {
            valueSet[bizConstants.standardControlID.subject].value = subject;
        }
        let noteBody = '';
        let isincludeIntralinks = false;
        noteBody = this._templateService.createNoteBodyHtml(valueSet);
        const action = new NoteAttachmentsAction();
        action.type = NoteAttachmentsActionTypes.DeleteAttachments;
        action.payload = {
            workflow: 'save',
            callback: (files) => {
                this._submitIntralinksData = [];
                const formData = {
                    body: noteBody,
                    // need to behave same as rich client. false means server will always update attachment no matter change or not
                    keepdoc: false,
                    // keepdoc: this._dirtyAttachments.length === 0 && this._categorizeNoteAction() === 'edit',
                };
                formData['draft'] = draftFlag;
                if (this._createEntryId && this._blastEmail) {
                    formData['blastemail'] = JSON.stringify({
                        'id': this._blastEmail.id,
                        'attachments': files,
                    });
                    if (this._blastEmail.originInfo) {
                        formData['originInfo'] = this._blastEmail.originInfo;
                    }
                } else {
                    if (this._noteAction === NoteActions.createNote && this._intralinksData) {
                        for (const data of this._intralinksData) {
                            const index = files.findIndex(item => item.split(':')[0] === data.id);
                            if (index > -1) {
                                isincludeIntralinks = true;
                                const file = data.id + ':' + data.fileHash + ':' + files[index].split(':')[2];
                                if (formData['intralinks-file']) {
                                    formData['intralinks-file'].push(file);
                                } else {
                                    formData['intralinks-file'] = [];
                                    formData['intralinks-file'].push(file);
                                }
                                this._submitIntralinksData.push(data);
                            }
                        }

                        if (isincludeIntralinks) {
                            formData['screen-id'] = this._intralinksData[0].screenId;
                            formData['intralinks-workspace-id'] = this._intralinksData[0].workspaceId;
                            for (const item of files) {
                                const index = this._intralinksData.findIndex(data => item.split(':')[0] === data.id);
                                if (index === -1) {
                                    if (formData['pretreatment-file']) {
                                        formData['pretreatment-file'].push(item);
                                    } else {
                                        formData['pretreatment-file'] = [];
                                        formData['pretreatment-file'].push(item);
                                    }
                                }
                            }
                        }
                    } else {
                        formData['pretreatment-file'] = files;
                    }
                }
                this._savingNote = true;
                const params = this._templateService.buildEntryTemplateParamsForWeb(valueSet, this._noteTypeId, this._noteAction, this.editingEntryId, false, !this._blastEmail, this.isDraft || this.isPlugInEditNoteMode, this._saveAction, this.isPlugInEditNoteMode);
                params.showattachmentsbyentry = true;
                // Use Graph API to indicate deposited emails
                if (this._noteAction === NoteActions.createNote) {
                    if (AddInUtilities.isOfficeEnvironment()) {
                        if (Office.context.host.toString() === AddInType.OUTLOOK) {
                            params['originInfo'] = {
                                source: MailBoxItemSource.Addin,
                                type: MailBoxItemType.Message,
                                itemId: Office.context.mailbox.item.itemId,
                                itemOwnerEmailAdd: Office.context.mailbox.userProfile.emailAddress
                            };
                        }
                    }
                }

                if (isincludeIntralinks) {
                    params.intralinks = true;
                }
                if (valueSet.removedentities) {
                    params.removedentities = valueSet.removedentities;
                }

                let updateThreadEntity;
                if (this._saveAction !== NoteActions.saveDraft) {
                    updateThreadEntity = this._updateThreadEntity();
                }
                // server required format for attaching files to current note.
                switch (this._noteAction) {
                    case NoteActions.createNote:
                        if (this.editingEntryId) {
                            this._noteTemplatePageViewModel.updateNote(this.editingEntryId, params, formData, draftFlag, auto, updateThreadEntity);
                        } else {
                            this._noteTemplatePageViewModel.createNote(params, formData, draftFlag, auto, updateThreadEntity, this._submitIntralinksData);
                        }
                        break;
                    case NoteActions.createSidenote:
                        this._noteTemplatePageViewModel.createNote(params, formData, draftFlag, auto, updateThreadEntity);
                        break;
                    case NoteActions.editNote:
                    case NoteActions.editSidenote:
                        this._noteTemplatePageViewModel.updateNote(this.editingEntryId, params, formData, draftFlag, auto, updateThreadEntity);
                        break;
                    default:
                        break;
                }
            }
        };
        this.noteAttachmentsConfig.actionSubject$.next(action);
    }

    private _categorizeNoteAction() {
        switch (this._noteAction) {
            case NoteActions.editNote:
            case NoteActions.editSidenote:
                return 'edit';
            case NoteActions.createNote:
            case NoteActions.createSidenote:
                return 'create';
            case NoteActions.deleteNote:
                return 'delete';
            case NoteActions.saveNote:
            case NoteActions.saveDraft:
            default:
                return 'other';
        }
    }

    private _setPluginPageStyle() {
        if ((this.isPlugInEditNoteMode || this.isOfficeAddinMode) && this._el.querySelector('.note-dialog')) {
            this.renderer.addClass(this._el.querySelector('.note-dialog'), 'note_dialog_container');
            this.renderer.addClass(this._el.querySelector('.note-dialog'), 'addin-dialog-container');
        } else if (this.isPopupEntry && this._el.querySelector('.note-dialog')) {
            this.renderer.addClass(this._el.querySelector('.note-dialog'), 'note_dialog_container_popup_entry');
        }
    }

    /**
     * only for web plugin
     * the value of 'hidden-note-dialog' should be 20 after click save/close/save draft button
     */
    private _setDialogCloseForPlugin() {
        if (this.isPlugInEditNoteMode) {
            this.isDialogClosedForPlugin = 20;
        }
    }

    private _setStaticDefaultValueForEdit(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForEdit(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['isDraft'] = this.isDraft || this.isPlugInEditNoteMode;
                    ctrl['firstEdit'] = true;
                    ctrl['isPlugin'] = this.isPlugInEditNoteMode || false;
                    ctrl['isPopoutEntry'] = this.isPopupEntry;
                    ctrl['prefixId'] = '';
                    if (!ctrl.isHidden && !this._findFirstControl && !this._specialCommonentTypes.includes(ctrl.componentType) && this._noteAction !== NoteActions.createSidenote && !this.isPlugInEditNoteMode) {
                        ctrl['isFirstControl'] = true;
                        this._findFirstControl = true;
                    }
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {
                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        if (this._entry && this._entry[adhocId] !== undefined) {
                            ctrl.fromEditSwitch = false;
                            // disable entities filed in create sidenote mode when parent note is not editable
                            if (ctrl.componentType === 'entity-input' && (this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote || this._noteAction === NoteActions.editNote)) {
                                ctrl.disabled = this._disableEntityField;
                            }
                            // only 1 entity in edit draft dialog and it's Uncategorized. hide it.
                            if (this.isDraft && adhocId === 'entities' && this._entry[adhocId].length === 1 && this._entry[adhocId][0] === this._unCategorizedId) {
                                ctrl.staticDefaultValue = [];
                            } else if (ctrl.componentType === 'displaydate-input' || ctrl.componentType === 'date-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                                ctrl.maxValue = this._entry.submittedDate;
                                ctrl['displaydate'] = this._entry.displaydate;
                                ctrl['lastEditDate'] = this._entry.lastEditDate;
                            } else if (ctrl.componentType === 'met-input' || ctrl.componentType === 'med-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                                ctrl.staticDefaultObject = this._currentEntity;
                            } else if (ctrl.componentType === 'tb-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                                if (typeof ctrl.staticDefaultValue === 'string') {
                                    ctrl.staticDefaultValue.split('\r\n').join('\n');
                                }
                            } else if (ctrl.componentType === 'msd-input') {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                            } else if (ctrl.componentType === 'ckeditor-input') {
                                ctrl.isPopoutEntry = this.isPopupEntry;
                            } else {
                                ctrl.staticDefaultValue = this._entry[adhocId];
                            }
                        } else if (this._entry && this._entry[adhocId] === undefined) {
                            if (ctrl.componentType !== 'sentiment-input' && ctrl.componentType !== 'priority-input' && ctrl.componentType !== 'ckeditor-input' && ctrl.defaultValue) {
                                ctrl.useDefaultValue = true;
                                ctrl.staticDefaultValue = undefined;
                            }
                        }
                    }
                }
            }
        }
        return config;
    }

    /**
     *
     * keep control value when user change note type .
     * @private
     * @param {*} config
     * @returns
     * @memberof NoteDialogComponent
     */
    private _setStaticDefaultValueForNoteTypeSwitching(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForNoteTypeSwitching(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['isDraft'] = this.isDraft;
                    ctrl['firstEdit'] = false;
                    ctrl['isPopoutEntry'] = this.isPopupEntry;
                    ctrl['prefixId'] = '';
                    ctrl['isSwitchNote'] = true;
                    ctrl.useDefaultValue = true;
                    if (!ctrl.isHidden && !this._findFirstControl &&
                        !this._specialCommonentTypes.includes(ctrl.componentType)) {
                        ctrl['isFirstControl'] = true;
                        this._findFirstControl = true;
                    }
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {
                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        ctrl.fromEditSwitch = true;
                        if (this._previousTemplateValueSet && this._previousTemplateValueSet[adhocId]
                            && this._previousTemplateValueSet[adhocId][ctrl.componentType] && !ctrl.isHidden) {
                            // disable entities field in create/edit sidenote mode when parent note is not editable
                            // disable entities field in edit note mode when one of sidenotes is note editable
                            if (ctrl.componentType === 'entity-input' && (this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote || this._noteAction === NoteActions.editNote)) {
                                ctrl.disabled = this._disableEntityField;
                            }
                            // only 1 entity in edit draft dialog and it's Uncategorized. hide it.
                            if (this.isDraft && adhocId === 'entities' && this._previousTemplateValueSet[adhocId][ctrl.componentType].value.length === 1 &&
                                this._previousTemplateValueSet[adhocId][ctrl.componentType].value === this._unCategorizedId) {
                                ctrl.staticDefaultValue = [];
                            } else if (ctrl.componentType === 'tb-input') {
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                                if (typeof ctrl.staticDefaultValue === 'string') {
                                    ctrl.staticDefaultValue = ctrl.staticDefaultValue.toString().split('\r\n').join('\n');
                                }
                            } else if (ctrl.componentType === 'displaydate-input' || ctrl.componentType === 'date-input') {
                                if (this._previousTemplateValueSet[adhocId][ctrl.componentType].value !== '') {
                                    ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value.getTime();
                                } else {
                                    ctrl.staticDefaultValue = '';
                                }
                                if (this._noteAction === NoteActions.createNote && this._blastEmail && this._blastEmail.time.getTime()) {
                                    ctrl.fromBlastEmail = true;
                                }
                                if (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.editSidenote && this._entry && this._entry.submittedDate) {
                                    ctrl.maxValue = this._entry.submittedDate;
                                }
                                if (AddInUtilities.isOfficeJSLoaded()) {
                                    // display date should not show the future date
                                    ctrl.maxValue = new Date().getTime();
                                }
                            } else if (ctrl.componentType === 'ckeditor-input') {
                                // default template configuration is from local ,but doesn't include the parameter of notebodyDetails.
                                // reset  _isPreNoteEntryForm = false;
                                this._isPreNoteEntryForm = false;
                                // Already has ctrl.NotebodyDetails. Add below properties for Notebody/EntryForm usage.
                                ctrl.entryId = this.editingEntryId;
                                ctrl.noteTypeId = this._noteTypeId;
                                // check isPlugInEditNoteMode&&editnote logic in notebody
                                ctrl.isPlugInEditNoteMode = this.isPlugInEditNoteMode;
                                // if last note type is EntryForm, clear note body in Note dialog;
                                // 1.if current note type is EntryForm , the note body class will load content as its own logic;
                                // 2.if current note type is non-EntryForm, the note body class use staticDefaultValue directly.
                                if (this._isPreNoteEntryForm) {
                                    ctrl.staticDefaultValue = '';
                                } else {
                                    // or else, kept the note body content.
                                    ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                                }
                                // keep current status.
                                if (ctrl.notebodyDetails) {
                                    this._isPreNoteEntryForm = ctrl.notebodyDetails.prepopulateTemplateChecked;
                                }
                                ctrl.isPopoutEntry = this.isPopupEntry;
                            } else {
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                            }
                        } else if (ctrl.isHidden && (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.editSidenote) && this._entry.submittedDate && (ctrl.componentType === 'displaydate-input' || ctrl.componentType === 'date-input')) {
                            ctrl.maxValue = this._entry.submittedDate;
                        }
                    }
                }
            }
        }
        return config;
    }

    // include set blastemail data as static value
    private _setStaticDefaultValueForCreate(config: any) {
        const entityIdList: Array<String> = new Array<String>();

        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForCreate(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    // Hide this code to fix TAM-34742
                    // if (!ctrl.isHidden && !this._findFirstControl && !this._specialCommonentTypes.includes(ctrl.componentType)) {
                    //     ctrl['isFirstControl'] = true;
                    //     this._findFirstControl = true;
                    // }
                    ctrl['prefixId'] = '';
                    ctrl['isSwitchNote'] = false;
                }

                if (this._noteAction === NoteActions.createNote && this._officeAddIn) {
                    // set defaul value for office add-in
                    if (ctrl.componentType === 'subject-input') {
                        ctrl.staticDefaultValue = this._officeAddIn.subject;
                    } else if (ctrl.componentType === 'ckeditor-input') {
                        if (AddInGlobalModel.currentAddInDepositType === AddInDepositType.ADDINALL) {
                            ctrl.staticDefaultValue = this._officeAddIn.body.replace(/<o:p>&nbsp;<\/o:p>/g, '');
                        } else {
                            // do not need to show note body in only email / only file mode.
                            ctrl.staticDefaultValue = '';
                        }
                    } else if (ctrl.componentType === 'displaydate-input') {
                        ctrl.staticDefaultValue = this._officeAddIn.receiveDate.getTime();
                        // display date should not show the future date
                        ctrl.maxValue = new Date().getTime();
                    } else if (ctrl.componentType === 'source-input') {
                        // set source id and source
                        if (this._officeAddIn.source) {
                            ctrl.staticDefaultValue = this._officeAddIn.source.id;
                            ctrl.staticDefaultObject = this._officeAddIn.source;
                        }
                    }
                } else if (this._noteAction === NoteActions.createNote && this._createEntryId && this._blastEmail) {
                    // set defaultValueFrom balstEmail
                    if (ctrl.componentType === 'entity-input') {
                        for (const value of this._blastEmail.entities) {
                            if (value.id !== businessConstants.entity.UnSpecified_Fixed_ID && value.id !== businessConstants.entity.Uncategorized_Fixed_ID) {
                                entityIdList.push(value.id);
                            }
                        }
                        ctrl.staticDefaultValue = entityIdList.join(';');
                    } else if (ctrl.componentType === 'source-input') {
                        if (this._blastEmail.contact) {
                            // set source id and source
                            ctrl.staticDefaultValue = this._blastEmail.contact.id;
                            ctrl.staticDefaultObject = this._blastEmail.contact;
                        }
                    } else if (ctrl.componentType === 'displaydate-input') {
                        ctrl.staticDefaultValue = this._blastEmail.time.getTime();
                        ctrl.fromBlastEmail = true;
                    } else if (ctrl.componentType === 'subject-input') {
                        ctrl.staticDefaultValue = this._blastEmail.subject;
                    } else if (ctrl.componentType === 'ckeditor-input') {
                        ctrl.staticDefaultValue = this._blastEmail.body.replace(/<o:p>&nbsp;<\/o:p>/g, '');
                    }
                } else if (this._noteAction === NoteActions.createNote && this._intralinksData) {
                    this._setStaticDefaultValueFromIntralinks(ctrl);
                }
            }
        }
        return config;
    }

    private _setStaticDefaultValueFromIntralinks(ctrl) {
        let createdDate = this._intralinksData[0].createdDate;
        this._intralinksData.forEach(item => {
            if (item.createdDate) {
                if (item.createdDate.getTime() < createdDate.getTime()) {
                    createdDate = item.createdDate;
                }
            }
        });
        if (ctrl.componentType === 'displaydate-input') {
            if (createdDate) {
                ctrl.staticDefaultValue = createdDate.getTime();
            }
            ctrl.defaultValue = null;
            ctrl.fromBlastEmail = true;
        }
        // If the selected files belong to multiple folders, some parameters in the dialog of the new note do not set default values, it is up to the customer to choose, if the selected files belong to a single folder, the default values of some parameters in the dialog are consistent with the mapping of the file
        if (!(this._isSelectMulFolder)) {
            if (ctrl.controlID === 'ENTITIES' && this._intralinksData[0].mapping && Array.isArray(this._intralinksData[0].mapping.entities)) {
                const entityIdList: Array<String> = new Array<String>();
                for (const value of this._intralinksData[0].mapping.entities) {
                    entityIdList.push(value.id);
                }
                ctrl.staticDefaultValue = entityIdList.join(';');
                ctrl.defaultValue = null;
                ctrl.fromBlastEmail = true;
            } else if (this._intralinksData[0].mapping && Array.isArray(this._intralinksData[0].mapping.fields)) {
                const found = this._intralinksData[0].mapping.fields.find(field => (ctrl.adhocDefID && field.adhocDefId === ctrl.adhocDefID) || (ctrl.label && field.label === this._labelRemoveAsterisk(ctrl.label) || ctrl.controlID === field.controlId));
                if (found) {
                    if (typeof found.value === 'boolean' || !!found.value) {
                        // Fix for [TAM-36614], the data of 'found.value' is timestamp.
                        // original code for reference. ctrl.staticDefaultValue = ctrl.componentType === 'date-input' ? found.value.getTime() : found.value;
                        ctrl.staticDefaultValue = found.value;
                    }
                    ctrl.defaultValue = null;
                    ctrl.fromBlastEmail = true;
                }
            }
        }

    }

    private _labelRemoveAsterisk(label: string): string {
        const name = label ? label.split(':')[0].trim() : '';
        return name.length > 0 ? name + ':' : name;
    }

    private _takeNoteBodyForEdit(noteBody) {
        if (noteBody && noteBody.body && noteBody.body.length > 0) {
            this._noteBodyHtml = noteBody.body;
            this._noteBodySubject.next({
                type: SET_NOTE_BODY_FOR_EDITING,
                payload: this._noteBodyHtml
            });
        }

        // Set confidence for auto tag entities
        if (this._noteBodyHtml && this._noteBodyHtml.length > 0) {
            const indexStart = this._noteBodyHtml.indexOf('<!-- START: auto tag metadata --><!--');
            const indexEnd = this._noteBodyHtml.indexOf('--><!-- END: auto tag metadata -->');
            const autoTagInfo = this._noteBodyHtml.substring(indexStart + 37, indexEnd);
            if (StringHelperService.isJsonString(autoTagInfo) && autoTagInfo.includes('autotag')) {
                this._autoTagEntities = JSON.parse(autoTagInfo).autotag;
                this.autoTagSubject.next({
                    type: 'TriggerByEditDraft',
                    payload: {
                        autoTagEntities: this._autoTagEntities
                    }
                });
            }
        }
    }

    private _takeTemplateMsg(msg) {
        let toastMsg;
        this._msgAction = msg;
        if (this.opened) {
            if (msg === DELETE_AUTOSAVED_DRAFT_SUCCESS) {
                this.close();
                this._clearData();
                this._noteTemplatePageViewModel.cleanTemplateMsg();
                localStorage.setItem('EntryAction', this._reloadDraft);
                // when user clik discard ,should delete draft first .thne close task panel
                // but if check 'this is event',should keep taskpanel
                if (!this.checkboxValue) {
                    AddInUtilities.closeTaskPaneForAddIn();
                }
            }
            const expectedMsgs = [CREATE_NOTE_SUCCESS, UPDATE_NOTE_SUCCESS, CREATE_DRAFT_SUCCESS, UPDATE_DRAFT_SUCCESS];
            if (expectedMsgs.includes(msg)) {
                if (msg === UPDATE_NOTE_SUCCESS) {
                    if (this._dialogOpenOptions.openType === NoteDialogType.EditDraft) {
                        // After convert draft to note, need refresh draft list
                        this._draftService.actionSubject$.next({ type: DraftActionType.RELOAD, payload: null });
                    } else {
                        localStorage.setItem('EntryTypeName', this._noteTypeDefalult.name);
                    }
                }
                if (this._dialogOpenOptions && this._dialogOpenOptions.isPopupEntryMode) {
                    const entryAction = {
                        saveAction: this._saveAction,
                        msgAction: this._msgAction
                    };
                    localStorage.setItem('EntryAction', JSON.stringify(entryAction));
                }
                if (this._noteAction === NoteActions.createNote) {
                    toastMsg = this._saveAction === NoteActions.saveNote ? StringLiteralsPipe.translate('note.note_successfully_created') : StringLiteralsPipe.translate('note.draft_successfully_created');
                    localStorage.setItem('EntryTypeName', this._noteTypeDefalult.name);
                    this._infoToast.style = NotificationStyles.Success;
                    if (AddInUtilities.isOfficeEnvironment()) {
                        // the entry created has been saved to store, we need to retrieve and show the entry link to user
                        const noteState = this._storeQuerier.queryBySelector(getNoteSelector);
                        if (noteState) {
                            this._addinEntryId = noteState.entry.id;
                            this.addinSubject = noteState.entry.calculatedTitle;
                        }
                        this.addinSuccessTip = this._saveAction === NoteActions.saveNote ? StringLiteralsPipe.translate('addin.note_successfully_created') : StringLiteralsPipe.translate('addin.draft_successfully_created');
                        this.isDialogHidden = true;
                    }
                } else if (this._noteAction === NoteActions.createSidenote) {
                    toastMsg = StringLiteralsPipe.translate('note.sidenote_successfully_created');
                    this._infoToast.style = NotificationStyles.Success;
                } else if (this._noteAction === NoteActions.editNote) {
                    if (this._dialogOpenOptions.openType === NoteDialogType.EditDraft) {
                        this._saveAction === NoteActions.saveNote ? this._infoToast.style = NotificationStyles.Success : this._infoToast.style = NotificationStyles.Success;
                        toastMsg = this._saveAction === NoteActions.saveNote ? StringLiteralsPipe.translate('note.note_successfully_created') : StringLiteralsPipe.translate('note.draft_successfully_updated');
                    } else {
                        this._infoToast.style = NotificationStyles.Success;
                        toastMsg = this._saveAction === NoteActions.saveNote ? StringLiteralsPipe.translate('note.note_successfully_updated') : StringLiteralsPipe.translate('note.draft_successfully_updated');
                    }
                    this._setDialogCloseForPlugin();
                } else if (this._noteAction === NoteActions.editSidenote) {
                    toastMsg = StringLiteralsPipe.translate('note.sidenote_successfully_updated');
                    this._infoToast.style = NotificationStyles.Success;
                }
                this._noteTemplatePageViewModel.cleanTemplateMsg();
                if (this._saveAction !== NoteActions.saveDraft) {
                    const relationshipArray = this._templateService.relationshipSaveAction(this._templateValueSet, null);
                    if (relationshipArray && relationshipArray.length > 0) {
                        this._noteTemplatePageViewModel.createRelationships(relationshipArray);
                    }
                }
                // add a time out because if delete a note through note option menu,
                // wait for the page navigation is done, then show toast on the previous page
                this._infoToast.message = toastMsg;

                setTimeout(() => {
                    // Hide notification in addin mode.
                    if (!this.isOfficeAddinMode) {
                        this._toast.notify(this._infoToast);
                    }
                }, AppConfig.subPageTransitionDuration);
                this._noteTemplatePageViewModel.cleanTemplateMsg();
                if (this._dialogOpenOptions.isPopupEntryMode) {
                    window.close();
                }

                // do not need to close note dialog in addin mode
                if (!AddInUtilities.isOfficeEnvironment()) {
                    this.close();
                    this._clearData();
                }

            } else if (msg.indexOf(CREATE_NOTE_FAILURE) === 0 || msg.indexOf(UPDATE_NOTE_FAILURE) === 0 || msg.indexOf(CREATE_DRAFT_FAILURE) === 0 || msg.indexOf(UPDATE_DRAFT_FAILURE) === 0 || msg.indexOf(DELETE_AUTOSAVED_DRAFT_FAILURE) === 0) {
                if (this._noteAction === NoteActions.createNote) {
                    toastMsg = this._saveAction === NoteActions.saveNote ? 'Note could not be created. Please try again.' : 'Draft could not be created. Please try again.';
                } else if (this._noteAction === NoteActions.createSidenote) {
                    toastMsg = 'Sidenote could not be created.';
                } else if (this._noteAction === NoteActions.editNote) {
                    toastMsg = this._saveAction === NoteActions.saveNote ? 'Note could not be updated.' : 'Draft could not be updated.';
                } else if (this._noteAction === NoteActions.editSidenote) {
                    toastMsg = 'Sidenote could not be updated.';
                }
                if (msg.indexOf(DELETE_AUTOSAVED_DRAFT_FAILURE) === 0) {
                    toastMsg = 'Draft could not be deleted. Please try again';
                }
                this._savingNote = false;
                this._infoToast.message = toastMsg;
                this._infoToast.style = NotificationStyles.Error;
                this._toast.notify(this._infoToast);
                this._noteTemplatePageViewModel.cleanTemplateMsg();
                if (this._noteDialogService.minimized === true) {
                    this.maxmize();
                }
                this.publishButtonHasBeenClicked = false;

            }
        }
    }

    /**
     * _takePrivacyConfiguration returns privacy enabled and privacySetting. if privacy isn't enabled, no more actions next.
     * @param configData. Formats:
     * {"privacySetting":"personal team",
     * "privacyEnabled":true,
     * "relationshipBasedDefaultingEnable":true,
     * "personTeamRelationshipTypeID":"21323ffe7f00001049f512df003f7c9e",
     * "primaryTeamRelationshipTypeID":"821dde770a16aed096cc99ec4f1a6df4"}
     */
    private _takePrivacyConfiguration(configData: any): any {
        this._privacyTeamsInited = false;
        if (configData !== null && configData !== undefined) {
            if (configData.privacyEnabled === true) {
                this.privacyEnabled = true;
                this._noteTemplatePageViewModel.getPrivacyTeams(configData);
                this.isPrivacy = true;
            } else {
                this.privacyEnabled = false;
                this.isPrivacy = false;
            }
        }
    }

    /**
     * _takePrivacyTeams sets the _privacyListConfig for privacy list usage.
     * @param privacyTeams
     */
    private _takePrivacyTeams(payload: any) {
        if (payload !== null && payload !== undefined) {
            this._privacyList = payload.privacyTeams;
            this._privacyListSource = this._privacyList;
            this.privacyListDefalult = payload.privacySelectedTeam;
            if (payload.privacySelectedTeam && payload.privacySelectedTeam.id) {
                this._privacyTeam = payload.privacySelectedTeam;
            }
            this._privacyTeamsInited = true;
        }
    }

    /**
     * get entry type list and default entry type
     * default entry type also include last edit entry type.
     * @private
     * @param {*} res
     * @returns
     * @memberof NoteDialogComponent
     */
    private _takeNoteType(res: any) {
        if (res == null) {
            return;
        }
        if (res.entryTypes && res.entryTypes.length > 0) {
            this._noteTypesSource = res.entryTypes.filter(item => item.usage && item.usage.indexOf(businessConstants.EntryTypes.note) > -1);
            ArrayHelperService.sort(this._noteTypesSource, 'name');
            this._noteTypes = this._noteTypesSource.slice();
        }
        if (this._createEntryId) {
            this._noteTypeId = this._createEntryId;
        } else {
            if (res.defaultEntryTypeId && res.defaultEntryTypeId.length > 0) {
                this._noteTypeId = res.defaultEntryTypeId;
            }
        }
        if (this.opened) {
            this._initDefaultNoteType(res);
        }
    }

    private _validateEntityChangesForSidenote(valueSet, dratFlag: boolean, auto: boolean = false) {
        const originEntitiesField = ArrayHelperService.uniqueArray(_lodash.cloneDeep(this._entry[StandardControlIds.entity.toLowerCase()])).sort().toString();
        let newEntitiesField = '';
        if (valueSet[StandardControlIds.entity] &&
            valueSet[StandardControlIds.entity].value &&
            valueSet[StandardControlIds.entity].value.length > 0) {
            newEntitiesField = ArrayHelperService.uniqueArray(valueSet[StandardControlIds.entity].value.split(';')).sort().toString();
        }
        if ((newEntitiesField !== originEntitiesField)
            && ((this._entry.totalNotesInThread > 1 && this._noteAction === NoteActions.editNote)
                || (this._noteAction === NoteActions.createSidenote)
                || (this._noteAction === NoteActions.editSidenote))) {
            const arrayMsg: string[] = [];
            if (this._entry.totalNotesInThread === 1) {
                arrayMsg.push('1 note is part of this thread.');
            } else if (this._entry.totalNotesInThread === 2) {
                arrayMsg.push('1 note and 1 sidenote are part of this thread.');
            } else if (this._entry.totalNotesInThread > 2) {
                arrayMsg.push('1 note and ' + (this._entry.totalNotesInThread - 1) + ' sidenotes are part of this thread.');
            }
            arrayMsg.push('\nAre you sure you want to change the entities on all items in this thread?');
            const subscription = this._alertWindow.warn('Confirmation', arrayMsg, 'Change', 'Go Back', this._dialogOpenOptions.eventKey, this._dialogOpenOptions.eventValue).subscribe((result: boolean) => {
                if (result) {
                    this._newEntitiesFieldValue = newEntitiesField.split(',');
                    this._saveNote(valueSet, dratFlag, auto);
                } else {
                    this.publishButtonHasBeenClicked = false;
                }
                subscription.unsubscribe();
            });
        } else {
            this._saveNote(valueSet, dratFlag, auto);
        }
        // thread detail side sheet should not be hideen when clicking the alert window
        this._alertWindow.openForSideSheet$.next('');
    }

    private close() {
        // when close the dialog, the publish button will work
        this.publishButtonHasBeenClicked = false;
        if (!this.isPlugInEditNoteMode) {
            if (this._dropzoneSubscription$) {
                this._dropzoneSubscription$.unsubscribe();
            }
            if (this._teamplateMsgSubscriptions) {
                this._teamplateMsgSubscriptions.unsubscribe();
            }
            this.opened = false;
            this._autoTagEntities = [];
            this._noteDialogService.opened = false;
            this._noteDialogService.minimized = false;
            if (!this.isPopupEntry && this._clickPopupEntry) {
                this._destroySubscriptions.push(fromEvent(window, 'storage').subscribe(event => this._listenPopupWindow(event)));
            }
            if (this._dialogOpenOptions.isPopupEntryMode) {
                window.close();
            }
            // in intralinks workflow, dialog is minimized
            if (this.dialogRef && this.dialogRef.minimized) {
                this.dialogRef.minimizeClose();
            }

        } else {
            this._setDialogCloseForPlugin();
        }
        // clean the remove entities store
        this._store.dispatch({
            type: CLEAN_REMOVE_ENTITIES
        });
        // clean the duplicated contact controls
        this._store.dispatch({
            type: CLEAR_DUPLICATED_CONTACT,
            payload: []
        });
        if (this.valueChangeSubscribtionForPer30 && !this.valueChangeSubscribtionForPer30.closed) {
            this.valueChangeSubscribtionForPer30.unsubscribe();
        }
        if (this.valueChangeSubscribtionForPer3 && !this.valueChangeSubscribtionForPer3.closed) {
            this.valueChangeSubscribtionForPer3.unsubscribe();
        }
    }

    private _listenPopupWindow(event) {
        let value;
        if (event.key === 'EntryAction') {
            if (event.newValue && event.newValue !== '' && event.newValue !== this._reloadDraft) {
                value = JSON.parse(event.newValue);
                const publishNoteResult = {
                    type: value.msgAction,
                    payload: value.msgAction
                };
                this._store.dispatch(publishNoteResult);
                this._infoToast.message = StringLiteralsPipe.translate('note.note_successfully_created');
                this._infoToast.message = value.saveAction === NoteActions.saveNote ? StringLiteralsPipe.translate('note.note_successfully_created') : StringLiteralsPipe.translate('note.draft_successfully_created');
                this._infoToast.style = NotificationStyles.Success;
                this._toast.notify(this._infoToast);
                this._noteTemplatePageViewModel.cleanTemplateMsg();
            }
            this._draftService.actionSubject$.next({ type: DraftActionType.RELOAD, payload: null });
            localStorage.setItem('EntryAction', '');
        }
    }

    /**
     * Show attachment list
     * @param res
     * @param isBlastEmail
     * @param isAddIn
     */
    private _onAttachmentLoaded(res, isBlastEmail, isAddIn?: boolean, isRefresh = false) {
        const action = new NoteAttachmentsAction();
        action.type = NoteAttachmentsActionTypes.SetAttachments;
        if (!isAddIn) {
            action.payload = { response: res, noteAction: this._noteAction, isBlastEmail: isBlastEmail, additionalFiles: this._dialogOpenOptions ? this._dialogOpenOptions.attachments : [] };
        } else {
            action.payload = { response: res, noteAction: NoteActions.createNote, isOfficeAddin: true, additionalFiles: [], isRefresh };
        }
        this.noteAttachmentsConfig.actionSubject$.next(action);
    }

    private _showAddInInfoOnNoteDialog(res) {
        const self = this;
        this._onAttachmentLoaded(res, false, true, true);
        this._currentAttachemtId = UUID.UUID();
        this._officeAddIn.uuid = this._currentAttachemtId;
        // clear attachments
        this._officeAddIn.attachments = [];
        this.attachmentUploading = true;
        // Some parts of the code runs out of the Angular zone, so add zone to update UI.
        let startTime = new Date();
        console.log('note-dialog get file data start: ' + startTime);
        this._destroySubscriptions.push(this._noteDialogService.getAllDataForAddIn(this._officeAddIn).subscribe(result => {
            let endTime = new Date();
            console.log('note-dialog get file data end: ' + endTime);
            console.log('note-dialog get file data time spent (ms): ' + (endTime.valueOf() - startTime.valueOf()));
            if (result) {
                self._officeAddIn = result;
                if (self._firstOpen) {
                    self._officeAddInOld = _lodash.cloneDeep(result);
                }
                self._zone.run(() => {
                    startTime = new Date();
                    console.log('note-dialog process template configuration data start: ' + startTime);
                    self._processNoteTemplateConfiguration(res);
                    endTime = new Date();
                    console.log('note-dialog process template configuration data end: ' + endTime);
                    console.log('note-dialog process template configuration data time spent (ms): ' + (endTime.valueOf() - startTime.valueOf()));
                });
            }
        }));

        switch (Office.context.host.toString()) {
            case AddInType.OUTLOOK:
                const officeMailboxItem = Office.context.mailbox.item;
                // When user clicks the 'Email only' icon, deposit the email into Tamale without attachment.
                if (AddInGlobalModel.currentAddInDepositType !== AddInDepositType.ADDINONLYFILE) {
                    // set email as an attachment
                    this._destroySubscriptions.push(
                        this._noteDialogService.getEmailContentForAddIn(this._officeAddIn, this._setAttachmentProgressStatus.bind(this)).subscribe(() => {
                        }));
                }

                // When user clicks the 'File(s) only' icon, deposit the email into Tamale without email content file.
                if (AddInGlobalModel.currentAddInDepositType !== AddInDepositType.ADDINONLYEMAIL) {
                    // handle attachments of email
                    const fileArray = officeMailboxItem.attachments.filter(attachment => !attachment.isInline);
                    if (fileArray.length === 0 && AddInGlobalModel.currentAddInDepositType === AddInDepositType.ADDINONLYFILE) {
                        this.attachmentUploading = false;
                        this._onAttachmentLoaded(null, false, true);
                    }
                    fileArray.forEach(att => {
                        this._destroySubscriptions.push(
                            this._noteDialogService.getEmailAttachmentsForAddIn(att, this._officeAddIn, this._setAttachmentProgressStatus.bind(this)).subscribe(() => {
                            }));
                    });
                }
                break;
            case AddInType.WORD:
            case AddInType.EXCEL:
            case AddInType.POWERPOINT:
                if (this._officeAddIn.subject) {
                    this._handleAddInDocuments();
                } else {
                    this.attachmentUploading = false;
                }
                this.isShowBtnClose = false;
                break;
            default:
                break;
        }
    }

    /**
     *  works for both excel and word add-in
     */
    private _handleAddInDocuments() {
        this._destroySubscriptions.push(
            this._noteDialogService.getAddInDocuments(this._officeAddIn, this._setAttachmentProgressStatus.bind(this)).subscribe(() => {
            }));
    }

    /**
     * callback attachment status and set progressbar.
     * @param res officeAddin data
     */
    private _setAttachmentProgressStatus(res) {
        if (res.uuid === this._currentAttachemtId) {
            if (res.attachments) {
                // exclude the deleted files
                this.attachmentUploading = res.attachments.filter(f => !this._deletedFileIds.includes(f.dzid)).findIndex(item => item.progress !== '100%') > -1;
                this._changeDetectorRef.detectChanges();
            }
            this._onAttachmentLoaded(res, false, true);
        }
    }
}
